import React, { useState, useEffect, useRef } from "react";
import "../DashBoard/sliding.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { contentReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Paper, TextField, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import ProductAccordion from "./Accordion";
import ApplicationAccordion from "./ApplicationAccordian";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";

function ListContent(props) {
  //Add content pop up
  const [popUp, setPopUp] = useState(false);
  const [deletepopUp, setdeletepopUp] = useState(false);

  //spinner for API
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    height: 300,
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    padding: "15px",
  };

  //Tiles or Table
  const [viewCards, setViewCards] = useState(true);

  //dummy state
  const [dub, setdub] = useState(0);

  const [accept, setAccept] = useState("");
  const [threeDcorrectFile, setThreeDcorrectFile] = useState(null);
  const [file3D, setFile3D] = useState(null);
  const [file3Dname, setFile3DName] = useState("");
  const [osType, setOsType] = useState("");
  const [add3DCinView, setAdd3DCinView] = useState(false);
  let [acceptArr, setAcceprArr] = useState([]);
  let [content1Arr, setContent1Arr] = useState([]);

  // Form data
  let [CTag, setCTag] = useState([]);
  let [CName, setCName] = useState([]);
  let [CType, setCType] = useState([]);
  let [CMin, setCMin] = useState([]);
  let [CSec, setCSec] = useState([]);
  let [CFormat, setCFormat] = useState([]);
  let [CDescription, setCDescription] = useState([]);
  let [CStatus, setCStatus] = useState([]);
  let [CUrl, setCUrl] = useState([]);
  let [CText, setCText] = useState([]);

  //File or URL
  let [fileRurl, setFileRUrl] = useState([]);

  //3D file submit status
  const [api3DStatus, setApi3DStatus] = useState("");

  //File Format
  let [fileType, setFileType] = useState([]);

  //File Upladd status
  const [apiAddStatus, setApiAddStatus] = useState([]);
  const [apiAddStatusMap, setApiAddStatusMap] = useState([]);
  const [failMsg, setFailMsg] = useState([]);
  const [existMsg, setExistMsg] = useState([]);
  const [successMsg, setSuccessMsg] = useState([]);
  const [failDisable, setFailDisble] = useState(false);
  const [isDelete, setisDelete] = useState(false);
  const [successCountState, setSuccessCountState] = useState(0);
  const [existCountState, setExistCountState] = useState(0);
  const [failCountState, setFailCountState] = useState(0);
  let [formValueThere, setFormValueThere] = useState(0);

  let failCount = 0;
  let existCount = 0;
  let successCount = 0;

  //Show By
  const [showBy, setShowBy] = useState("All content");

  let [formValues, setFormvalues] = useState([]);

  //View content
  const [viewContentPopUp, setViewContentPopUp] = useState(false);
  const [contentPopUpType, setContentPopUpType] = useState("");
  const [contentPopUpFormat, setContentPopUpFormat] = useState("");
  const [contentPopUpSrc, setContentPopUpSrc] = useState("");
  const defaultUrl = "Image Cannot be dispalyed!";
  const [colvisible, setcolvisible] = useState(false);
  const editdisable = false;
  const [viewContentPopUpDetails, setViewContentPopUpDetails] = useState([]);

  const viewContentPopUpStyle = {
    position: "absolute",
    backgroundColor: "white",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95vw",
    // overflowY: "auto",
    height: "95vh",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };
  const viewContentFunction = async (item) => {
    console.log("vcccccccc", item);

    if (item.te_contenttype !== "text") {
      // Only convert to blob for PDF files
      if (item.te_contentformat === "pdf") {
        try {
          const resp = await fetch(item.te_contenturl);

          // Ensure we got a valid response
          if (!resp.ok) {
            throw new Error(`HTTP error! status: ${resp.status}`);
          }

          // Create blob with explicit PDF MIME type
          const blob = await resp.blob();
          const pdfBlob = new Blob([blob], { type: "application/pdf" });
          const url = URL.createObjectURL(pdfBlob);
          setContentPopUpSrc(url);
        } catch (error) {
          console.error("Error converting PDF to blob:", error);
          // Fallback to direct URL if blob conversion fails
          setContentPopUpSrc(item.te_contenturl);
        }
      } else {
        // For all other file formats, use direct URL
        setContentPopUpSrc(item.te_contenturl);
      }
    } else {
      setContentPopUpSrc(item.te_contenttext);
    }

    setViewContentPopUp(true);
    setContentPopUpType(item.te_contenttype);
    console.log("contentPopUpFormat", item);
    setContentPopUpFormat(item.te_contentformat);
    setViewContentPopUpDetails(item);
  };

  let handleChangeTrial = (i, e) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormvalues(newFormValues);
    // console.log(formValues);
  };

  const [addExtra, setaddExtra] = useState(false);
  const [add3DContent, setadd3DContent] = useState(false);
  const [add3DContentfiles, setadd3DContentfiles] = useState(false);

  // responseBy Product UseState
  const [prodResponse, setProdResponse] = useState([]);

  const [ApplicationResponse, setApplicationResponse] = useState([]);
  const [AppRespMain, setAppRespMain] = useState([]);
  const ref = useRef();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  let addFormFields = () => {
    let newForm = new FormData();
    setFormvalues([...formValues, newForm]);
    setFileType([...fileType, []]);

    //Form values
    setCTag([...CTag, ""]);
    setCName([...CName, ""]);
    setCType([...CType, ""]);
    setCMin([...CMin, ""]);
    setCSec([...CSec, ""]);
    setCFormat([...CFormat, ""]);
    setCDescription([...CDescription, ""]);
    setCStatus([...CStatus, ""]);
    setCUrl([...CUrl, ""]);
    setCText([...CText, ""]);

    //File or URL
    setFileRUrl([...fileRurl, ""]);

    //enable or disable duration and file format
    setShowhide([...showhide, ""]);

    //FormValueCount
    setFormValueThere((val) => val + 1);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormvalues(newFormValues);
    let newFileType = [...fileType];
    newFileType.splice(i, 1);
    setFileType(newFileType);
    fileRurl.splice(i, 1);
    showhide.splice(i, 1);
    console.log("fileurl", fileRurl);
    //FormValues Remove
    CTag.splice(i, 1);
    CName.splice(i, 1);
    CType.splice(i, 1);
    CMin.splice(i, 1);
    CSec.splice(i, 1);
    CFormat.splice(i, 1);
    CDescription.splice(i, 1);
    CStatus.splice(i, 1);
    CUrl.splice(i, 1);
    CText.splice(i, 1);

    //FormValueCount
    setFormValueThere((val) => val - 1);
  };

  // Dispatch function
  const dispatch = useDispatch();

  const content_btn = useSelector((state) => state.content.content_btn);

  let [showhide, setShowhide] = useState([]);
  const [textvalidated, settextvalidated] = useState(false);

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  // console.log("token11111111111111", token);

  //content Edit related selectors
  const content_3Did = useSelector((state) => state.content.content_3Did);
  const content_id = useSelector((state) => state.content.content_id);
  const content_name = useSelector((state) => state.content.content_name);
  const content_tag = useSelector((state) => state.content.content_tag);
  const content_fileName = useSelector(
    (state) => state.content.content_fileName
  );
  const content_format = useSelector((state) => state.content.content_format);
  const content_description = useSelector(
    (state) => state.content.content_description
  );

  // const division_edit = useSelector((state) => state.content.division_edit);
  // const product_edit = useSelector((state) => state.content.product_edit);
  const content_IsPane = useSelector((state) => state.content.contentIsPane);
  const addcontent_IsPane = useSelector(
    (state) => state.content.addContentIsPane
  );
  const addcontent_IsPane1 = useSelector(
    (state) => state.content.addContentIsPane1
  );

  //state hook for listcontent API's
  const [contentData, setcontentData] = useState([]);
  const [contentCount, setcontentCount] = useState(null);

  const [contentDesc, setContentDesc] = useState("");

  const [productID, setProductID] = useState("");

  // hook for edit content api
  const [EcontentID, setEcontentID] = useState("");

  const [EcontentName, setEcontentName] = useState("");
  const [EcontentTag, setEcontentTag] = useState("");
  const [EcontentType, setEcontentType] = useState("");
  const [EcontentFormat, setEcontentFormat] = useState("");
  const [EcontentURL, setEcontentURL] = useState("");
  const [EcontentText, setEcontentText] = useState("");
  const [Econtent3Dfilename, setEcontent3Dfilename] = useState("");
  const [Econtent3DOs, setEcontent3DOs] = useState("");
  const [Econtent3Dpath, setEcontent3Dpath] = useState("");

  const [EcontentFileName, setEcontentFileName] = useState("");
  const [EcontentDesc, setEcontentDesc] = useState("");

  const [EcontentStatus, setEcontentStatus] = useState("");

  const [showhide1, setShowhide1] = useState("");

  const [divisionData, setdivisionData] = useState([]);

  const [viewContentTable, setViewContentTable] = useState([]);

  // filtering
  const [ContentFilter, setContentFilter] = useState("");
  const [ContentselData, setContentselData] = useState("");

  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);

  const [dummyContentselData, setDummyContentselData] = useState("");

  const content_filter = useSelector((state) => state.content.content_filter);
  const [editpopUp, seteditPopUp] = useState(false);
  const [edit3DpopUp, setedit3DPopUp] = useState(false);

  //Permission for Roles
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );
  // const Download_Permission = useSelector((state) => state.AccessTocken.Download_Permission);

  //View content update
  const bu_viewcontent = useSelector((state) => state.content.bu_viewcontent);
  const division_viewcontent = useSelector(
    (state) => state.content.division_viewcontent
  );
  const productId_View = useSelector(
    (state) => state.content.productId_viewcontent
  );
  const product_viewcontent = useSelector(
    (state) => state.content.product_viewcontent
  );
  const col1_visible = useSelector((state) => state.content.col1_visible);

  const [Edit3D, setEdit3D] = useState(false);

  //Header for API's
 const options = {
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json', // Add this if missing
  },
};
console.log("Request headers:", options.headers);
const responseData = async () => {
  // Validate token before making requests
  if (!token || token.trim() === '') {
    console.error('No valid token available');
    dispatch(sidebarReducer.stringUpdate("AuthError"));
    return;
  }

  // Create options with proper error handling
  const createOptions = () => ({
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    timeout: 10000 // 10 second timeout
  });

  dispatch(sidebarReducer.apiLoad(true));
  
  try {
    // First API call - content/view
    const contentResponse = await axios.get(
      `content/view/?page=1&limit=${listLimit}`, 
      createOptions()
    );
    
    if (contentResponse.status === 200) {
      console.log("Content response:", contentResponse);
      let pages = contentResponse.data.data.count === 0 
        ? 1 
        : Math.ceil(contentResponse.data.data.count / listLimit);
      
      setcontentCount(contentResponse.data.data.count);
      setNoOfPages(pages);
      
      const filteredArray = contentResponse.data.data.rows.filter((item) => {
        return item.te_isdeleted === "0";
      });
      
      setcontentData(filteredArray);
    }

    // Second API call - businessunit/listactive
    const buResponse = await axios.get(`businessunit/listactive`, createOptions());
    
    if (buResponse.status === 200) {
      setBuData(buResponse.data.data);
    }

    // Third API call - content/listcontentsbyproduct (the problematic one)
    try {
      const prodResponse = await axios.get(
        `content/listcontentsbyproduct`, 
        createOptions()
      );
      
      if (prodResponse.status === 200) {
        setProdResponse(prodResponse.data.data.Rows);
      }
    } catch (prodError) {
      console.error("Product content API error:", prodError);
      // Handle this specific API error separately
      if (prodError.response?.status === 400 || prodError.response?.status === 401) {
        console.error("Authorization issue with product content API");
        // You might want to show a specific error message or retry logic here
      }
    }

    // Fourth API call - content/listcontentsbyapp
    try {
      const applicationResponse = await axios.get(
        `content/listcontentsbyapp`, 
        createOptions()
      );
      
      if (applicationResponse.status === 200) {
        let mainArr = applicationResponse.data.data.Rows;
        setAppRespMain(applicationResponse.data.data.Rows);
        
        let processedArr = mainArr.map(
          ({ te_application_id, te_application_name, product }) => {
            let contentArr = product.map(
              ({ productName, contents, division }) => {
                const { divisionname, business_unit } = division;
                const { buName } = business_unit;
                let newCArr = contents.map((data) => {
                  data["product_Name"] = productName;
                  data["division_Name"] = divisionname;
                  data["bu_Name"] = buName;
                  return data;
                });
                return newCArr;
              }
            );

            return {
              Appid: te_application_id,
              AppName: te_application_name,
              content: contentArr.flat(),
            };
          }
        );
        setApplicationResponse(processedArr);
      }
    } catch (appError) {
      console.error("Application content API error:", appError);
      if (appError.response?.status === 400 || appError.response?.status === 401) {
        console.error("Authorization issue with application content API");
      }
    }

  } catch (error) {
    console.error("API Error:", error);
    
    // Handle different types of errors
    if (error.response) {
      // Server responded with error status
      console.error("Error status:", error.response.status);
      console.error("Error data:", error.response.data);
      
      if (error.response.status === 401 || error.response.status === 403) {
        dispatch(sidebarReducer.stringUpdate("AuthError"));
      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error("Network error - no response received");
      dispatch(sidebarReducer.stringUpdate("NetworkError"));
    } else {
      // Something else happened
      console.error("Request setup error:", error.message);
      dispatch(sidebarReducer.stringUpdate("AppDown"));
    }
  } finally {
    dispatch(sidebarReducer.apiLoad(false));
  }
};

  const [contentForm, setContentForm] = useState("");

  const img = ["gif", "jpeg", "jpg", "png"];
  const vid = ["mp4", "avi", "mov"];
  const aud = ["mp3", "mpeg"];
  const docs = ["pdf", "docx", "txt", "odt"];

  const [mapper, setMapper] = useState([]);

  // eslint-disable-next-line
  let mapIndex = 0;
  //Add content API
  const handleMapping = (e) => {
    let val = e;
    mapIndex = val;

    switch (val) {
      case "image":
        setEcontentType("image");
        setMapper(mapper);
        setMapper(img);
        break;
      case "audio":
        setMapper(aud);
        setEcontentType("audio");
        break;
      case "video":
        setMapper(vid);
        setEcontentType("video");
        break;
      case "file":
        setMapper(docs);
        setEcontentType("application");
        break;
      default:
        break;
    }
  };

  const [buData, setBuData] = useState([]);

  async function DivData(opt) {
    const response = await axios.get(`division/listactive/${opt}`, options);
    return setdivisionData(response.data.data);
  }

  const [productData, setProductData] = useState([]);

  //Pagenation
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, ContentselData, ContentFilter);
  };

  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, ContentselData, ContentFilter);
  };

  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, ContentselData, ContentFilter);
  };

  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, ContentselData, ContentFilter);
  };

  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      setPageSelected(pageNo);
      setcontentData([]);
      dispatch(sidebarReducer.apiLoad(true));
      await axios
        .get(`content/view/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            const Array = response.data.data.rows.filter((item) => {
              return item.te_isdeleted === "0";
            });
            console.log(Array, "Arr");
            setcontentData(Array);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        });
    } else if (isFiltered) {
      setPageSelected(pageNo);
      dispatch(sidebarReducer.apiLoad(true));
      if (!isFilterIReset) {
        await axios
          .get(
            `content/view/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              const Array = response.data.data.rows.filter((item) => {
                return item.te_isdeleted === "0";
              });
              console.log(Array, "Arr");
              setcontentData(Array);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      } else if (isFilterIReset) {
        dispatch(sidebarReducer.apiLoad(true));
        await axios
          .get(
            `content/view/?page=${pageNo}&limit=${listLimit}&${dummyContentselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              const Array = response.data.data.rows.filter((item) => {
                return item.te_isdeleted === "0";
              });
              console.log(Array, "Arr");
              setcontentData(Array);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    }
  };

  // async function fetchProductID(val) {
  //   await axios
  //     .get(`masterproduct/listactive/${val}`, options)
  //     .then((response) => setProductData(response.data.data))
  //     .catch((err) => dispatch(sidebarReducer.stringUpdate("AppDown")));
  // }
  useEffect(() => {
    fetchProducts();
  }, []);

  async function fetchProducts() {
    try {
      const response = await axios.get(
        `masterproduct/list/?page=1&limit=${listLimit}`,
        options
      );
      setProductData(response.data.data.rows);
      // console.log("abbbbbbbb",response.data)
    } catch (err) {
      console(err);
      // dispatch(sidebarReducer.stringUpdate("AppDown"));
    }
  }

  //Update content API
  let NewFormData = new FormData();

  const onUpdate = async (content_id) => {
    NewFormData.set("teContentTag", EcontentTag);
    NewFormData.set("teContentName", EcontentName);
    NewFormData.set("teContentType", EcontentType);
    NewFormData.set("teContentFileName", EcontentFileName);
    NewFormData.set("teContentDescription", EcontentDesc);
    NewFormData.set("teProductId", productID);
    NewFormData.set("teContentStatus", EcontentStatus); // if(EcontentType ===)

    EcontentType === "text"
      ? NewFormData.set("teContentText", EcontentText)
      : NewFormData.set("teContentUrl", EcontentURL);

    // dispatch(sidebarReducer.apiLoad(true));
    axios
      .put(`content/update/${content_id}`, NewFormData, options)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.update_success(true));
          tableupdate(productID);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
        // console.log(response);
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));

        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.update_failure(true));
        dispatch(sidebarReducer.update_success(false));
      });
  };

  let editForm3D = new FormData();

  //3d update function
  const on3DUpdate = async (item) => {
    // console.log("productID", item);
    editForm3D.set("ostype", Econtent3DOs);
    editForm3D.set("contentfilename", Econtent3Dfilename);
    editForm3D.set("threeDContentId", content_id);
    editForm3D.set(
      "productid",
      showBy === "Product" ? productId_View : productID
    );
    editForm3D.set("status", "1");
    editForm3D.set("filepath", Econtent3Dpath);
    // console.log("editform", editForm3D);

    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(`threedcontent/update/${item}`, editForm3D, options)
      .then((response) => {
        // console.log("eee", editForm3D);
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.update_success(true));
          setFile3DName(Econtent3Dfilename);
          setOsType(Econtent3DOs);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => dispatch(sidebarReducer.stringUpdate("AppDown")));
  };

  const tableupdate = async (productID) => {
    dispatch(sidebarReducer.apiLoad(true));

    await axios
      .get(`content/list/${productID}`, options)
      .then((response) => {
        dispatch(sidebarReducer.apiLoad(false));

        setViewContentTable(response.data.data.rows);
        console.log("abc", response.data.data.rows);
        dispatch(contentReducer.content_btn(true));
        responseData();
      })
      .catch((err) => dispatch(sidebarReducer.apiLoad(false)));
    await axios
      .get(`threedcontent/findByProductId/${productID}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          let res = [response.data.data];
          res.map((item, index) => {
            setFile3DName(item.te_filename);
            setOsType(item.te_ostype);
            dispatch(contentReducer.content_3Did(item.te_3dmodelcontentid));
            return null;
          });
          if (
            response.data.message ===
            "3DCONTENT BY PRODUCTID FOUND SUCCESSFULLY"
          ) {
            setaddExtra(true);
            setadd3DContent(false);
            setadd3DContentfiles(false);
          } else if (response.data.message === "NO PRODUCTID FOUND") {
            setadd3DContent(true);
            setaddExtra(false);
            dispatch(contentReducer.col1_visible(false));
          }
        }
      })
      .catch((err) => dispatch(sidebarReducer.apiLoad(false)));
  };

  //3D Content
  let threeDFormData = new FormData();
  const [fileUrl, setFileUrl] = useState(null);
  const change3DFile = (e) => {
    let val = e.target.files[0];
    let type = val.type;

    const Url = URL.createObjectURL(val);
    setFileUrl(Url);
    console.log("File URL:", Url);

    console.log({
      fileName: val.name,
      blobUrl: Url,
      fileSize: val.size,
      lastModified: val.lastModified,
      type: val.type,
    });
    if (type === "") {
      setThreeDcorrectFile(false);
      setFile3D(val);
    } else {
      setThreeDcorrectFile(true);
    }
    // setfilevalidated(val);

    threeDFormData.append("file", file3D);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formatMismatchMsg, setFormatMismatchMsg] = useState("");
  const validateFileFormats = () => {
    let hasFormatMismatch = false;
    let mismatchCount = 0;

    formValues.forEach((item, i) => {
      const file = item.get("content");
      const selectedFormat = CFormat[i]; // Selected format from dropdown
      const contentType = CType[i]; // Selected content type (video, audio, image, file)

      if (file && selectedFormat && contentType !== "text") {
        // Get file extension from the uploaded file
        const fileName = file.name;
        const fileExtension = fileName.split(".").pop().toLowerCase();

        // Check if the file extension matches the selected format
        if (fileExtension !== selectedFormat.toLowerCase()) {
          hasFormatMismatch = true;
          mismatchCount++;

          // Mark this specific form entry as having format mismatch
          apiAddStatus[i] = "FM"; // FM = Format Mismatch
          apiAddStatusMap[i] = "FM";
        }
      }
    });

    if (hasFormatMismatch) {
      setFormatMismatchMsg(
        `${mismatchCount} ${
          mismatchCount > 1 ? "files have" : "file has"
        } format mismatch. Please upload files matching the selected format.`
      );

      // Update the content array to show format mismatch status
      const updatedStates = [...apiAddStatus];
      setContent1Arr(updatedStates);

      // Show popup with error message
      setPopUp(true);
      return false;
    }

    return true;
  };

async function onSubmit3D(e) {
  e.preventDefault();

  // Prevent multiple submissions
  if (isSubmitting) return;

  if (!validateFileFormats()) {
    return; // Stop submission if validation fails
  }
  setIsSubmitting(true); // Disable submit button immediately
  dispatch(sidebarReducer.apiLoad(true));

  setFormatMismatchMsg("");
  try {
    // CRITICAL: Set loading state immediately for all valid entries
    const tempLoadingStates = [...content1Arr];
    formValues.forEach((item, i) => {
      const file = item.get("content");
      if (file && file.size) {
        tempLoadingStates[i] = "L";
      }
    });

    // Add 3D model to loading states if it exists
    if (addExtra === true && file3D) {
      tempLoadingStates.push("L"); // Add loading state for 3D model
      setApi3DStatus("L");
    }

    setContent1Arr(tempLoadingStates);

    const presignedRequestData = {
      filename: [],
      filsize: [],
      contentType: [],
      teProductId: [],
    };

    const validFormEntries = [];

    // Populate the request data from formValues
    formValues.forEach((item, i) => {
      const file = item.get("content");
      const contentType = item.get("teContentType");

      if (!file || !file.size) {
        console.warn(`Skipping form entry ${i}: No file found`);
        apiAddStatus[i] = "F";
        apiAddStatusMap[i] = "F";
        failCount++;
        const updatedStates = [...apiAddStatus];
        setContent1Arr(updatedStates);
        return;
      }

      const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2) + " MB";

      presignedRequestData.filename.push(file.name);
      presignedRequestData.filsize.push(fileSizeInMB);
      presignedRequestData.contentType.push(contentType);
      presignedRequestData.teProductId.push(productID);

      validFormEntries.push({ formValue: item, originalIndex: i });
    });

    // Add 3D model to the bulk request if it exists
    if (addExtra === true && file3D) {
      const fileSizeInMB = (file3D.size / (1024 * 1024)).toFixed(2) + " MB";
      
      presignedRequestData.filename.push(file3Dname);
      presignedRequestData.filsize.push(fileSizeInMB);
      presignedRequestData.contentType.push("3DObject"); // Set content type as 3DObject
      presignedRequestData.teProductId.push(productID);

      // Create a mock FormData-like object for 3D file
      const mock3DFormValue = new Map();
      mock3DFormValue.set("content", file3D);
      mock3DFormValue.set("teContentType", "3DObject");
      mock3DFormValue.set("teContentName", file3Dname);
      mock3DFormValue.set("teContentFormat", file3D.name.split('.').pop()); // Get file extension
      mock3DFormValue.set("teContentTag", "3DObject");
      mock3DFormValue.set("teContentSubType", "");
      mock3DFormValue.set("teContentDescription", "3D Model Content");
      mock3DFormValue.set("teContentmin", "0");
      mock3DFormValue.set("teContentsec", "0");

      validFormEntries.push({ 
        formValue: mock3DFormValue, 
        originalIndex: formValues.length, // Use next available index
        is3DModel: true 
      });
    }

    if (validFormEntries.length === 0) {
      console.warn("No valid form entries with files found");
      const updatedStates = [...apiAddStatus];
      setContent1Arr(updatedStates);
      return;
    }

    // Initialize loading state for all form items that have files
    const initialLoadingStates = [...apiAddStatus];
    validFormEntries.forEach((entry) => {
      initialLoadingStates[entry.originalIndex] = "L";
      apiAddStatus[entry.originalIndex] = "L";
      apiAddStatusMap[entry.originalIndex] = "L";
    });
    setContent1Arr([...initialLoadingStates]);

    // Step 1: Get presigned URLs for bulk upload
    const presignedResponse = await axios.post(
      `content/get-presigned-url-bulk`,
      presignedRequestData,
      options
    );

    if (presignedResponse.status === 200) {
      const presignedData = presignedResponse.data.data;

      // Step 2: Upload files to S3 using presigned URLs
      const s3UploadPromises = presignedData.map(async (urlData, i) => {
        const file = validFormEntries[i].formValue.get("content");

        try {
          await axios.put(urlData.preSignedUrl, file, {
            headers: {
              "Content-Type": urlData.contentType,
            },
          });
          return {
            success: true,
            index: i,
            urlData,
            originalIndex: validFormEntries[i].originalIndex,
            is3DModel: validFormEntries[i].is3DModel || false,
          };
        } catch (error) {
          console.error(`S3 upload failed for file ${i}:`, error);
          const originalIndex = validFormEntries[i].originalIndex;
          apiAddStatus[originalIndex] = "F";
          apiAddStatusMap[originalIndex] = "F";
          
          // Update 3D model status if it's a 3D model
          if (validFormEntries[i].is3DModel) {
            setApi3DStatus("F");
          }
          
          const updatedStates = [...apiAddStatus];
          setContent1Arr(updatedStates);
          return { success: false, index: i, error, originalIndex, is3DModel: validFormEntries[i].is3DModel || false };
        }
      });

      const s3Results = await Promise.all(s3UploadPromises);

      // Step 3: Prepare metadata for adds3metadata-bulk API
      const metadataRequestData = [];

      s3Results.forEach((result, i) => {
        if (result.success) {
          const formValue = validFormEntries[i].formValue;
          const urlData = result.urlData;

          metadataRequestData.push({
            te_contenttag: formValue.get("teContentTag") || "",
            teContentName: formValue.get("teContentName") || urlData.filename,
            teContentType: urlData.contentType, // This will be "3DObject" for 3D models
            te_contentSubType: formValue.get("teContentSubType") || "",
            te_ContentUrl: urlData.fileKey,
            te_contentfilepath: urlData.contentfilepath,
            te_filesize: urlData.filesize,
            teContentFileName:
              urlData.filename + "." + formValue.get("teContentFormat"),
            teContentFormat: formValue.get("teContentFormat") || "",
            te_contentdescription:
              formValue.get("teContentDescription") || contentDesc,
            teContentDuration:
              formValue.get("teContentmin") + formValue.get("teContentsec"),
            teProductId: productID,
          });
        }
      });

      // Step 4: Add metadata to database
      if (metadataRequestData.length > 0) {
        await axios
          .post(`content/adds3metadata-bulk`, metadataRequestData, options)
          .then((res) => {
            if (res.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));

              res.data.data.forEach((item, i) => {
                const originalIndex = validFormEntries[i].originalIndex;
                const is3DModel = validFormEntries[i].is3DModel;

                if (item.status === "SUCCESS") {
                  apiAddStatus[originalIndex] = "S";
                  apiAddStatusMap[originalIndex] = "S";
                  successCount++;
                  
                  // Update 3D model status if it's a 3D model
                  if (is3DModel) {
                    setApi3DStatus("S");
                  }
                } else {
                  if (item.message && item.message.includes("already exists")) {
                    apiAddStatus[originalIndex] = "FE";
                    apiAddStatusMap[originalIndex] = "FE";
                    existCount++;
                    
                    // Update 3D model status if it's a 3D model
                    if (is3DModel) {
                      if (item.message.includes("productid")) {
                        setApi3DStatus("PE");
                      } else {
                        setApi3DStatus("FNE");
                      }
                    }
                  } else {
                    apiAddStatus[originalIndex] = "F";
                    apiAddStatusMap[originalIndex] = "F";
                    failCount++;
                    
                    // Update 3D model status if it's a 3D model
                    if (is3DModel) {
                      setApi3DStatus("F");
                    }
                  }
                }
              });

              const updatedStates = [...apiAddStatus];
              setContent1Arr(updatedStates);
            }
          })
          .catch((error) => {
            dispatch(sidebarReducer.apiLoad(false));
            console.error("Metadata bulk add failed:", error);

            validFormEntries.forEach((entry, i) => {
              apiAddStatus[entry.originalIndex] = "F";
              apiAddStatusMap[entry.originalIndex] = "F";
              failCount++;
              
              // Update 3D model status if it's a 3D model
              if (entry.is3DModel) {
                setApi3DStatus("F");
              }
            });

            const updatedStates = [...apiAddStatus];
            setContent1Arr(updatedStates);
          });
      }

      // Handle S3 upload failures
      s3Results.forEach((result) => {
        if (!result.success) {
          apiAddStatus[result.originalIndex] = "F";
          apiAddStatusMap[result.originalIndex] = "F";
          failCount++;
          
          // Update 3D model status if it's a 3D model
          if (result.is3DModel) {
            setApi3DStatus("F");
          }
        }
      });

      const finalUpdatedStates = [...apiAddStatus];
      setContent1Arr(finalUpdatedStates);
    }
  } catch (error) {
    dispatch(sidebarReducer.apiLoad(false));
    console.error("Presigned URL generation failed:", error);

    formValues.forEach((item, i) => {
      apiAddStatus[i] = "F";
      apiAddStatusMap[i] = "F";
      failCount++;
    });

    // Update 3D model status on error
    if (addExtra === true && file3D) {
      setApi3DStatus("F");
      failCount++;
    }

    const errorUpdatedStates = [...apiAddStatus];
    setContent1Arr(errorUpdatedStates);
  } finally {
    // Always re-enable the submit button when done
    setIsSubmitting(false);
  }

  console.log(apiAddStatus);

  // Update popup logic to account for 3D model
  const total3DCount = addExtra && file3D ? 1 : 0;
  const totalExpectedCount = formValueThere + total3DCount;

  if (successCount + failCount + existCount === totalExpectedCount) {
    setPopUp(true);
  }

  setSuccessCountState(successCount);
  setExistCountState(existCount);
  setFailCountState(failCount);

  if (failCount > 0) {
    setFailMsg(
      `${failCount} ${
        failCount > 1 ? "Contents" : "Content"
      } failed, Please try again!`
    );
  }

  if (existCount > 0) {
    setExistMsg(
      `${existCount} ${
        existCount > 1 ? "Contents" : "Content"
      } already existed.`
    );
  }

  if (successCount === totalExpectedCount) {
    setSuccessMsg("Content added successfully!");
  } else if (successCount > 0 && successCount < totalExpectedCount) {
    setSuccessMsg(
      `${successCount} ${
        successCount > 1 ? "Contents" : "Content"
      } added successfully!`
    );
  } else if (successCount === 0) {
    setSuccessMsg("");
  }
}

  // Reset the data after conetnt added successfully or not added successfully.
  const resetAddContent = () => {
    setPopUp(false);
    dispatch(contentReducer.addContent_IsPane(false));
    dispatch(contentReducer.division_edit(false));
    dispatch(contentReducer.product_edit(false));
    dispatch(contentReducer.content_btn(false));
    setFormvalues([]);
    setContentFilter("");
    setContentselData("");
    setaddExtra(false);
    setThreeDcorrectFile(null);
    setApi3DStatus("");
    setContent1Arr([]);
    setAcceprArr([]);
    setFileType([]);
    setFileRUrl([]);
    setMapper([]);
    existCount = 0;
    failCount = 0;
    successCount = 0;
    setSuccessMsg("");
    setApiAddStatus([]);
    setFile3D(null);
    setFailMsg("");
    setExistMsg("");
    setFailDisble(false);
    setFormValueThere(0);
    setEcontentText("");
    setEdit3D(false);
    setApiAddStatusMap([]);

    setCTag([]);
    setCName([]);
    setCType([]);
    setCMin([]);
    setCSec([]);
    setCFormat([]);
    setCDescription([]);
    setCStatus([]);
    setCUrl([]);
    setCText([]);
    // responseData();
  };

  const resetAddContent1 = () => {
    setPopUp(false);
    dispatch(contentReducer.addContent_IsPane1(false));
    dispatch(contentReducer.division_edit(false));
    dispatch(contentReducer.product_edit(false));
    dispatch(contentReducer.content_btn(false));
    setFormvalues([]);
    setContentFilter("");
    setContentselData("");
    setaddExtra(false);
    setThreeDcorrectFile(null);
    setApi3DStatus("");
    setContent1Arr([]);
    setAcceprArr([]);
    setFileType([]);
    setFileRUrl([]);
    setMapper([]);
    existCount = 0;
    failCount = 0;
    successCount = 0;
    setSuccessMsg("");
    setApiAddStatus([]);
    setFile3D(null);
    setFailMsg("");
    setExistMsg("");
    setFailDisble(false);
    setFormValueThere(0);

    setApiAddStatusMap([]);

    setCTag([]);
    setCName([]);
    setCType([]);
    setCMin([]);
    setCSec([]);
    setCFormat([]);
    setCDescription([]);
    setCStatus([]);
    setCUrl([]);
    setCText([]);
    // responseData();
  };

  // When content got failed
  const failAddCase = () => {
    setPopUp(false);
    existCount = 0;
    failCount = 0;
    successCount = 0;
    setExistCountState(0);
    setFailCountState(0);
    setSuccessCountState(0);
    setSuccessMsg("");
    setFailMsg("");
    setExistMsg("");
    if (addExtra && api3DStatus === "F") {
      setApi3DStatus("");
    } else {
      setaddExtra(false);
    }

    for (let i = 0; i < apiAddStatusMap.length; i++) {
      if (apiAddStatusMap[i] === "S" || apiAddStatusMap[i] === "FE") {
        formValues.splice(i, 1);
        fileType.splice(i, 1);
        fileRurl.splice(i, 1);
        showhide.splice(i, 1);
        apiAddStatus.splice(i, 1);

        //FormValues Remove
        CTag.splice(i, 1);
        CName.splice(i, 1);
        CType.splice(i, 1);
        CMin.splice(i, 1);
        CSec.splice(i, 1);
        CFormat.splice(i, 1);
        CDescription.splice(i, 1);
        CStatus.splice(i, 1);
        CUrl.splice(i, 1);
        CText.splice(i, 1);
      }
      if (i === apiAddStatusMap.length - 1) {
        setFormValueThere((num) => (num = apiAddStatus.length));
      }
    }
    // setFailDisble(true);
  };

  //Select a user from the table to get the pop up
  async function on3DEdit(item) {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`threedcontent/list/${item}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          const resp = response.data.data.rows[0];

          setEcontent3Dfilename(resp.te_filename);
          setEcontent3DOs(resp.te_ostype);
          setEcontent3Dpath(resp.te_filepath);

          dispatch(contentReducer.content_3DfileName(resp.te_contentfilename));
          dispatch(contentReducer.content_3Dos(resp.te_ostype));
          dispatch(contentReducer.content_id(resp.te_3dmodelcontentid));
          dispatch(contentReducer.content_productID(item.te_productid));

          dispatch(
            contentReducer.content_description(item.te_contentdescription)
          );
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  async function onEdit(item) {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`content/details/${item.te_contentid}`, options)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          setEcontentURL(item.te_contenturl);
          setEcontentTag(item.te_contenttag);
          setEcontentDesc(item.te_contentdescription);
          setEcontentFormat(item.te_contentformat);
          setEcontentType(item.te_contenttype);
          setEcontentStatus(item.te_contentstatus);
          setEcontentName(item.te_contentname);
          setEcontentFileName(item.te_contentname);

          dispatch(contentReducer.content_id(item.te_contentid));
          dispatch(contentReducer.content_name(item.te_contentname));
          dispatch(contentReducer.content_tag(item.te_contenttag));
          dispatch(contentReducer.content_fileName(item.te_contentfilename));
          dispatch(contentReducer.content_status(item.te_contentstatus));
          dispatch(contentReducer.content_type(item.te_contenttype));
          dispatch(contentReducer.content_productID(item.te_productid));
          dispatch(contentReducer.content_format(item.te_contentformat));
          dispatch(
            contentReducer.content_description(item.te_contentdescription)
          );
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  const onCancel = () => {
    setEcontentID(content_id);
    setEcontentName(content_name);
    setEcontentTag(content_tag);
    setEcontentDesc(content_description);
    setEcontentFileName(content_fileName);
    setEcontentFormat(content_format);
    seteditPopUp(false);
    setedit3DPopUp(false);
  };
  const onDelete = async (id) => {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .delete(`content/delete/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          setdeletepopUp(false);
          dispatch(sidebarReducer.delete_success(true));
          tableupdate(productID);
          responseData();
        } else if (response.status !== 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.delete_success(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // for filtering
  const handleSearch = (e, TargetColomn, keyWord) => {
    if (showBy === "All content") {
      apiFilter(e, TargetColomn, keyWord);
    } else if (showBy === "Product") {
      productResp(TargetColomn, keyWord);
    } else if (showBy === "Applications") {
      appResp(TargetColomn, keyWord);
    }
  };
  const apiFilter = async (e, TargetColomn, keyWord) => {
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));

    await axios
      .get(
        `content/view/?limit=${listLimit}&${TargetColomn}=${keyWord}`,
        options
      )
      .then((resp) => {
        if (resp.status === 200) {
          console.log("eeeeeeeeerrrrr", resp);
          dispatch(sidebarReducer.apiLoad(false));
          const Array = resp.data.data.rows.filter((item) => {
            return item.te_isdeleted === "0";
          });
          console.log(Array, "Arr");

          setcontentData(Array);

          setcontentCount(resp.data.data.count);

          let pages;
          resp.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(resp.data.data.count / listLimit));
          setNoOfPages(pages);

          dispatch(contentReducer.content_filter(false));
        } else if (resp.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        console.log("eeeeeeeeerrrrr", err);
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };
  const productResp = (TargetColomn, keyWord) => {
    let apiResp = prodResponse;
    let word = keyWord.toLowerCase();
    let newResp;
    if (TargetColomn === "te_buname") {
      newResp = apiResp.filter((data) => {
        let bu = data.division.business_unit.buName.toLowerCase();
        return bu === word;
      });
      setProdResponse(newResp);
    } else if (TargetColomn === "te_divisionname") {
      newResp = apiResp.filter((data) => {
        let div = data.division.divisionname.toLowerCase();
        return div === word;
      });
      setProdResponse(newResp);
    } else if (TargetColomn === "te_productname") {
      newResp = apiResp.filter((data) => {
        let product = data.productName.toLowerCase();
        return product === word;
      });
      setProdResponse(newResp);
    }
  };
  const appResp = (TargetColomn, keyWord) => {
    let apiResp = AppRespMain;
    let word = keyWord.toLowerCase();
    let filterResp;
    if (TargetColomn === "te_appname") {
      filterResp = apiResp.filter((data) => {
        let app = data.te_application_name.toLowerCase();
        return app === word;
      });
      let newArr = filterResp.map(
        ({ te_application_id, te_application_name, product }) => {
          let contentArr = product.map(
            ({ productName, contents, division }) => {
              const { divisionname, business_unit } = division;
              const { buName } = business_unit;
              let newCArr = contents.map((data) => {
                data["product_Name"] = productName;
                data["division_Name"] = divisionname;
                data["bu_Name"] = buName;
                return data;
              });
              return newCArr;
            }
          );

          let obj = {
            Appid: te_application_id,
            AppName: te_application_name,
            content: contentArr.flat(),
          };
          return obj;
        }
      );
      setApplicationResponse(newArr);
    } else if (TargetColomn === "te_divisionname") {
      // filterResp = apiResp.map((data) => {
      //   let productArr = data.product;
      //   let filteredArr = productArr.filter((info,i) => {
      //     let div = info.division.divisionname.toLowerCase();
      //     return word === div;
      //   });
      //   return filteredArr;
      // });
      // filterResp = apiResp.filter((data) => {
      //   let div = data.division.divisionname.toLowerCase();
      //   return div === word;
      // // });
      // let newArr = filterResp.map(
      //   ({ te_application_id, te_application_name, product }) => {
      //     let contentArr = product.map(
      //       ({ productName, contents, division }) => {
      //         const { divisionname, business_unit } = division;
      //         const { buName } = business_unit;
      //         let newCArr = contents.map((data) => {
      //           data["product_Name"] = productName;
      //           data["division_Name"] = divisionname;
      //           data["bu_Name"] = buName;
      //           return data;
      //         });
      //         return newCArr;
      //       }
      //     );
      //     let obj = {
      //       Appid: te_application_id,
      //       AppName: te_application_name,
      //       content: contentArr.flat(),
      //     };
      //     return obj;
      //   }
      // );
      // setApplicationResponse(newArr);
    }
    //  else if (TargetColomn === "te_productname") {
    //   filterResp = apiResp.filter((data) => {
    //     let product = data.productName.toLowerCase();
    //     return product === word;
    //   });
    //   let newArr = filterResp.map(
    //     ({ te_application_id, te_application_name, product }) => {
    //       let contentArr = product.map(
    //         ({ productName, contents, division }) => {
    //           const { divisionname, business_unit } = division;
    //           const { buName } = business_unit;
    //           let newCArr = contents.map((data) => {
    //             data["product_Name"] = productName;
    //             data["division_Name"] = divisionname;
    //             data["bu_Name"] = buName;
    //             return data;
    //           });
    //           return newCArr;
    //         }
    //       );

    //       let obj = {
    //         Appid: te_application_id,
    //         AppName: te_application_name,
    //         content: contentArr.flat(),
    //       };
    //       return obj;
    //     }
    //   );
    //   setApplicationResponse(newArr);
    // }
  };
  const handleReset = () => {
    responseData();
    setContentFilter("");
    setContentselData("");
    // setDummyContentFilter("");
    setDummyContentselData("");
    setIsFilterIReset(false);
    dispatch(contentReducer.content_filter(true));
  };

  const handleReset1 = (e) => {
    setContentFilter("");
    setContentselData("");
  };
  const audioStyle = {
    width: "60%",
    borderRadius: "8px",
    backgroundColor: "#009900",
    padding: "10px",
  };

  const getDisabledStyles = (isDisabled = false) => ({
    cursor: isDisabled ? "not-allowed" : "pointer",
    opacity: isDisabled ? 0.6 : 1,
    pointerEvents: isDisabled ? "none" : "auto",
  });

  const getDisabledIconColor = (isDisabled = false) => ({
    color: isDisabled ? "#ccc" : "inherit",
  });
  return (
    <div>
      {View_Permission === 1 ? (
        // <div className={`${viewCards ? "Immage" : null} container-fluid`}>
        <div className={`container-fluid`}>
          {/** total content part in the layout */}
          <div className="row">
            {/** ROW 1 for header */}
            <div className="col-12 p-0 Image" style={{ minHeight: "100vh" }}>
              <div className="row g-0 p-0">
                <div className="col">
                  <div
                    className=" g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0 border-bottom">
                      <div className="col-3" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>AR Content</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-9">
                        <div className="d-flex flex-row-reverse me-3">
                          <div className="p-2">
                            {viewCards && showBy !== "Product" && (
                              <button
                                className="btn add-button"
                                style={{
                                  backgroundColor: "white",
                                  // color: "#009900",
                                  minWidth: "100px",
                                  //  display :"none"
                                }}
                                onClick={() => {
                                  dispatch(
                                    contentReducer.addContent_IsPane1(true)
                                  );
                                }}
                              >
                                &nbsp;
                                <span
                                  className="ToolTipU"
                                  // style={{
                                  //   backgroundColor: "white",
                                  // }}
                                >
                                  <i className="bi bi-view-list"></i>&nbsp; View
                                  AR Content
                                  <span
                                    className="ToolTipTextU"
                                    style={{
                                      backgroundColor:
                                        View_Permission === 1 ? "white" : "red",
                                      border:
                                        View_Permission === 1
                                          ? "1px solid black"
                                          : "red",
                                      color:
                                        View_Permission === 1 ? "black" : "red",
                                    }}
                                  >
                                    {View_Permission === 1
                                      ? "View the AR Content."
                                      : "You cannot view the AR Content."}
                                  </span>
                                </span>
                              </button>
                            )}
                            {showBy === "Product" && (
                              <button
                                className="btn add-button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                  color: "white",
                                  minWidth: "100px",
                                  display: "none",
                                }}
                                onClick={() => {
                                  dispatch(
                                    contentReducer.addContent_IsPane1(true)
                                  );
                                  handleReset();
                                  setFormvalues([]);
                                  setadd3DContentfiles(false);
                                  setadd3DContent(false);
                                }}
                              >
                                &nbsp;
                                <span
                                  className="ToolTipU"
                                  style={{
                                    backgroundColor: "var(--themes-color)",
                                  }}
                                >
                                  <i className="bi bi-view-list"></i>&nbsp; View
                                  AR Content
                                  <span
                                    className="ToolTipTextU"
                                    style={{
                                      backgroundColor:
                                        View_Permission === 1
                                          ? "#FFA300"
                                          : "red",
                                    }}
                                  >
                                    {View_Permission === 1
                                      ? "View the AR Content."
                                      : "You cannot view the AR Content."}
                                  </span>
                                </span>
                              </button>
                            )}
                          </div>

                          <div className="p-2">
                            <button
                              className="btn add-button"
                              style={{
                                backgroundColor: "white",
                                // color: "#009900",
                                minWidth: "100px",
                              }}
                              onClick={() => {
                                if (Add_Permission === 1) {
                                  dispatch(
                                    contentReducer.addContent_IsPane(true)
                                  );
                                  handleReset();
                                  setFormvalues([]);
                                }
                              }}
                            >
                              <span
                                className="ToolTipU"
                                // style={{
                                //   backgroundColor: "white",
                                // }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add AR
                                Content
                                <span
                                  className="ToolTipTextU"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1 ? "white" : "red",
                                    border:
                                      Add_Permission === 1
                                        ? "1px solid black"
                                        : "red",
                                    color:
                                      Add_Permission === 1 ? "black" : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "Add new AR Content."
                                    : "You cannot add a AR Content."}
                                </span>
                              </span>
                            </button>
                          </div>
                          <div className="dropdown p-2">
                            {content_filter ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "80px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  // handleSearch(
                                  //   e,
                                  //   ContentselData,
                                  //   ContentFilter.toLowerCase()
                                  // );
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{ backgroundColor: "white" }}
                                onClick={() => {
                                  handleReset();
                                  // setTableHeight(false);
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                          <div className="p-2 dropdown">
                            <div
                              className="ps-1 py-2 pe-0"
                              // type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              style={
                                viewCards ? null : { visibility: "hidden" }
                              }
                            >
                              <strong style={{ cursor: "pointer" }}>
                                {showBy}
                              </strong>
                              <span className="ps-1 pt-3">
                                <i className="bi bi-caret-down-fill"></i>
                              </span>
                            </div>
                            <ul className="dropdown-menu">
                              {/* <li
                                className="dropdown-item py-1"
                                onClick={() => setShowBy("Applications")}
                                style={{ cursor: "pointer" }}
                              >
                                Applications
                              </li> */}

                              <li
                                className="dropdown-item py-1"
                                onClick={() => setShowBy("Product")}
                                style={{ cursor: "pointer" }}
                              >
                                Product
                              </li>
                              <li
                                className="dropdown-item py-1"
                                onClick={() => setShowBy("All content")}
                                style={{ cursor: "pointer" }}
                              >
                                All Content
                              </li>
                            </ul>
                          </div>
                          <div className="p-2">
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <Typography
                                sx={
                                  !viewCards
                                    ? { fontWeight: "bold", scale: "1.2" }
                                    : null
                                }
                              >
                                Table
                              </Typography>
                              <Switch
                                checked={viewCards}
                                onChange={() => {
                                  setViewCards(!viewCards);
                                  setShowBy("All content");
                                }}
                                inputProps={{ "aria-label": "controlled" }}
                                sx={{
                                  "& .MuiSwitch-thumb": {
                                    backgroundColor: "#009900", // Thumb color
                                  },
                                  "& .MuiSwitch-track": {
                                    backgroundColor: viewCards
                                      ? "#66BB6A !important"
                                      : "#B0BEC5",
                                  },
                                  "& .MuiSwitch-switchBase.Mui-checked": {
                                    color: "#009900", // Thumb color when checked
                                  },
                                }}
                              />
                              <Typography
                                sx={
                                  viewCards
                                    ? { fontWeight: "bold", scale: "1.2" }
                                    : null
                                }
                              >
                                Cards
                              </Typography>
                            </Stack>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/** ROW 2 for table */}
              <div className="row g-0 p-0">
                <div className="col">
                  <div className="container-fluid g-0">
                    {!content_IsPane &&
                      !addcontent_IsPane &&
                      !addcontent_IsPane1 && (
                        <div className="accordion" id="accordionExample">
                          {/* <div className="accordion-item"> */}
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div
                              className="accordion-body d-flex align-items-end p-2 "
                              style={{
                                backgroundColor: "#00ca431c",
                                height: "90px",
                              }}
                            >
                              <div className="d-flex flex-row justify-content-between ">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 2 },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        width: "20ch",
                                        zIndex: "0",
                                      },
                                    }}
                                    value={ContentFilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setContentFilter(val);
                                      // setDummyContentFilter(val);
                                    }}
                                  />
                                  <FormControl sx={{ width: "20ch" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelid="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={ContentselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setContentselData(val);
                                        setDummyContentselData(val);
                                      }}
                                    >
                                      {showBy === "All content" ? (
                                        <MenuItem value="te_contentname">
                                          Content Name
                                        </MenuItem>
                                      ) : null}
                                      {showBy === "All content" ? (
                                        <MenuItem value="te_contenttag">
                                          Content Tag
                                        </MenuItem>
                                      ) : null}
                                      {showBy === "All content" ? (
                                        <MenuItem value="te_contenttype">
                                          Content Type
                                        </MenuItem>
                                      ) : null}
                                      {showBy === "All content" ? (
                                        <MenuItem value="te_contentfilename">
                                          Content filename
                                        </MenuItem>
                                      ) : null}
                                      {showBy === "All content" ? (
                                        <MenuItem value="te_contentformat">
                                          Content format
                                        </MenuItem>
                                      ) : null}
                                      {showBy === "All content" ? (
                                        <MenuItem value="te_contentdescription">
                                          Content description
                                        </MenuItem>
                                      ) : null}
                                      {showBy !== "Applications" ? (
                                        <MenuItem value="te_buname">
                                          Business Unit
                                        </MenuItem>
                                      ) : null}
                                      {showBy !== "Applications" ? (
                                        <MenuItem value="te_divisionname">
                                          Division
                                        </MenuItem>
                                      ) : null}

                                      {showBy === "Product" ? (
                                        <MenuItem value="te_productname">
                                          Product
                                        </MenuItem>
                                      ) : null}
                                      {showBy === "Applications" ? (
                                        <MenuItem value="te_appname">
                                          Application
                                        </MenuItem>
                                      ) : null}
                                    </Select>
                                  </FormControl>
                                </Box>

                                <div
                                  className="d-flex flex-row justify-content-around g-0"
                                  style={{ marginLeft: "-25px" }}
                                >
                                  <button
                                    className="btn add-button text-white mx-4"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "85px",
                                      position: "relative",
                                      top: "17px",
                                      right: "-30px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(
                                        e,
                                        ContentselData,
                                        ContentFilter
                                      );
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      ContentFilter.length > 0 &&
                                      ContentFilter.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "85px",
                                      position: "relative",
                                      top: "17px",
                                      left: "40px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                    }}
                                    disabled={
                                      ContentFilter.length > 0 &&
                                      ContentFilter.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                        </div>
                      )}
                    {!viewCards && (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ height: "80vh" }}
                      >
                        {!apiLoad ? (
                          <div>
                            <table
                              // className="table table-hoverborder-top-0 table-wrapper-scroll-y my-custom-scrollbar"
                              className="table table-hover ListUserTable ListContentTable border-top-0"
                              ref={ref}
                              style={{ overflowX: "auto" }}
                            >
                              <thead style={{ backgroundColor: "#ecedef" }}>
                                <tr style={{ textAlign: "left" }} e="true">
                                  <th className="border">Content Name</th>
                                  <th className="border">Content Tag</th>
                                  <th className="border">Content Type</th>
                                  <th className="border">Content filename</th>
                                  <th className="border">Content format</th>
                                  <th className="border">
                                    content description
                                  </th>
                                  <th className="border">product name</th>
                                  <th className="border">BU Name</th>
                                  <th className="border">Division Name</th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "left" }}>
                                {contentData.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan={9}
                                      className=" border text-center mb-0"
                                    >
                                      NO DATA FOUND
                                    </td>
                                  </tr>
                                ) : (
                                  contentData.map((item, index) => (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: `${
                                          item.te_contentid === content_id &&
                                          content_IsPane === true
                                            ? " #f2f3f5"
                                            : " #fff"
                                        }`,
                                      }}
                                      onClick={() => {
                                        viewContentFunction(item);
                                      }}
                                    >
                                      <td className="border text-start">
                                        {item.te_contentname}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_contenttag}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_contenttype}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_contentfilename}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_contentformat}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_contentdescription}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_productname}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_buname}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_divisionname}
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                            <div style={{ height: "100px" }}></div>
                          </div>
                        ) : (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        )}
                      </div>
                    )}
                    {viewCards && showBy === "All content" && (
                      <div>
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <div className="ContentCardMain d-flex flex-wrap border-top">
                            {contentData.length === 0 ? (
                              <h6
                                style={{
                                  marginLeft: "500px",
                                  marginTop: "10px",
                                }}
                              >
                                No Data Found{" "}
                              </h6>
                            ) : (
                              contentData.map((item, index) => {
                                return item.te_isdeleted === "0" ? (
                                  <div
                                    className="ms-5 mt-5"
                                    key={index}
                                    onClick={() => {
                                      viewContentFunction(item);
                                    }}
                                  >
                                    <div
                                      className={`card shadow-sm mb-3 content${
                                        item.te_contenttype === "video"
                                          ? "Video"
                                          : item.te_contenttype === "image"
                                          ? "Image"
                                          : item.te_contenttype === "audio"
                                          ? "Audio"
                                          : item.te_contenttype === "file"
                                          ? "File"
                                          : item.te_contenttype === "text"
                                          ? "Text"
                                          : null
                                      }`}
                                      style={{
                                        height: "250px",
                                        borderRadius: "10px",
                                        maxWidth: "245px",
                                        minWidth: "245px",
                                        border: "2px solid #009900 !important",
                                      }}
                                    >
                                      <div className="top"></div>
                                      <div
                                        className="logoContent"
                                        style={{ borderRadius: "25px" }}
                                      >
                                        <img
                                          style={{
                                            height: "50px",
                                            width: "50px",
                                          }}
                                          src={
                                            item.te_contentformat === "png"
                                              ? require("../../images/png1.png")
                                              : item.te_contentformat === "jpg"
                                              ? require("../../images/jpg1.png")
                                              : item.te_contentformat === "pdf"
                                              ? require("../../images/pdf1.png")
                                              : item.te_contentformat === "gif"
                                              ? require("../../images/gif1.png")
                                              : item.te_contentformat === "jpeg"
                                              ? require("../../images/jpeg1.png")
                                              : item.te_contentformat === "mp4"
                                              ? require("../../images/mp41.png")
                                              : item.te_contentformat === "txt"
                                              ? require("../../images/txt1.png")
                                              : item.te_contentformat === "mp3"
                                              ? require("../../images/mp31.png")
                                              : item.te_contentformat === "docx"
                                              ? require("../../images/doc1.png")
                                              : item.te_contentformat === "mov"
                                              ? require("../../images/mov.png")
                                              : null
                                          }
                                          alt="C_LOGO"
                                        />
                                      </div>
                                      <span className="ToolTipP">
                                        <p
                                          className="pt-4 mt-1 ps-2 m-0"
                                          style={{ fontSize: "1rem" }}
                                        >
                                          {item.te_contentname}
                                        </p>
                                        <span className="ToolTipTextP">
                                          Content Name
                                        </span>
                                      </span>
                                      <span className="ToolTipP">
                                        <p
                                          className="ps-2 m-0"
                                          style={{ fontSize: "0.8rem" }}
                                        >
                                          {item.te_buname} /{" "}
                                          {item.te_divisionname}
                                        </p>
                                        <span className="ToolTipTextP">
                                          Business Unit/ Division
                                        </span>
                                      </span>
                                      <span className="ToolTipP">
                                        <p className="ps-2 mb-0">
                                          {item.te_contentformat}
                                        </p>
                                        <span className="ToolTipTextP">
                                          Content Format
                                        </span>
                                      </span>
                                      {item.te_contentstatus === "1" && (
                                        <div
                                          className="rounded-start text-center text-white"
                                          style={{
                                            position: "absolute",
                                            width: "80px",
                                            backgroundColor: "rgb(58,201,53)",
                                            top: "8px",
                                            right: "0px",
                                            height: "20px",
                                          }}
                                        >
                                          <span
                                            className=""
                                            style={{
                                              fontSize: "14px",
                                              position: "relative",
                                              top: "-2px",
                                            }}
                                          >
                                            Active
                                          </span>
                                        </div>
                                      )}
                                      {item.te_contentstatus === "0" && (
                                        <div
                                          className="rounded-start text-center text-white"
                                          style={{
                                            position: "absolute",
                                            width: "80px",
                                            backgroundColor: "rgb(201,53,53)",
                                            top: "8px",
                                            right: "0px",
                                            height: "20px",
                                          }}
                                        >
                                          <span
                                            className=""
                                            style={{
                                              fontSize: "14px",
                                              position: "relative",
                                              top: "-2px",
                                            }}
                                          >
                                            InActive
                                          </span>
                                        </div>
                                      )}
                                      <hr
                                        className="m-0"
                                        style={{
                                          marginTop: "2px",
                                          marginBottom: "2px",
                                        }}
                                      />
                                      <span className="ToolTipP">
                                        <div className="card-body pt-2 ps-1">
                                          <p
                                            className="g-0"
                                            style={{
                                              maxWidth: "90%",
                                              minWidth: "89%",
                                              maxHeight: "10px",
                                              fontSize: "11px",
                                            }}
                                          >
                                            {item.te_contentdescription}
                                          </p>
                                        </div>
                                        <span className="ToolTipTextP">
                                          Content Description
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                ) : null;
                              })
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {viewCards && showBy === "Product" && (
                      <div style={{ height: "95vh", overflowY: "auto" }}>
                        {prodResponse.map((item, index) => (
                          <ProductAccordion
                            parentItem={item}
                            key={index}
                            tableupdate={tableupdate}
                          />
                        ))}
                        <div style={{ height: "150px" }}></div>
                      </div>
                    )}

                    {viewCards && showBy === "Applications" && (
                      <div style={{ height: "95vh", overflowY: "auto" }}>
                        {ApplicationResponse.map((item, index) => (
                          <ApplicationAccordion
                            parentItem={item}
                            key={index}
                            tableupdate={tableupdate}
                          />
                        ))}
                        <div style={{ height: "150px" }}></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/** ROW 3 for pagenation ! it should not visible when popup are there */}
            </div>

            {/* pagination footer */}
            {!apiLoad && showBy !== "Product" && showBy !== "Applications" && (
              <div className="container">
                <div className="row main-footer">
                  <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                    Total Records: {contentCount}
                  </div>
                  <div className="col-4 mt-2">
                    <div className="d-flex justify-content-center ">
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            leftEndArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== 1 && leftArrow();
                          }}
                        ></i>
                      </div>
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index1_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index1_pagenation,
                            ContentselData,
                            ContentFilter
                          );
                        }}
                      >
                        {index1_pagenation}
                      </div>
                      {noOfPages > 1 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index2_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index2_pagenation,
                              ContentselData,
                              ContentFilter
                            );
                          }}
                        >
                          {index2_pagenation}
                        </div>
                      )}
                      {noOfPages > 2 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index3_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index3_pagenation,
                              ContentselData,
                              ContentFilter
                            );
                          }}
                        >
                          {index3_pagenation}
                        </div>
                      )}
                      {noOfPages > 3 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index4_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index4_pagenation,
                              ContentselData,
                              ContentFilter
                            );
                          }}
                        >
                          {index4_pagenation}
                        </div>
                      )}
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== noOfPages && rightArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            rightEndArrow();
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 mt-2 ">
                    <div className="d-flex justify-content-end me-3">
                      <span>
                        <strong>Page {pageSelected} </strong> of{" "}
                        <strong>{noOfPages}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/** SlidingPan pop up for Viewing content data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="75%"
            hideHeader
            isOpen={addcontent_IsPane1}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              // onCancel();
              threeDFormData = new FormData();
              setAdd3DCinView(false);
            }}
          >
            <div className="container-fluid " style={{ height: "100%" }}>
              <div
                className="row p-0 align-items-center border "
                style={{
                  height: "6%",
                  backgroundColor: "#e6f2f7",
                  paddingBottom: "0px !important",
                  borderColor: "#e6f2f7 !important",
                }}
              >
                <div className="col-3 ">
                  <div className="d-flex align-items-center flex-row">
                    <div
                      className="px-2 my-1 d-flex align-items-center justify-content-center"
                      onClick={() => {
                        dispatch(sidebarReducer.stringUpdate("ListContent"));
                        resetAddContent1();
                        setisDelete(false);
                        setcolvisible(false);
                        setAdd3DCinView(false);
                        threeDFormData = new FormData();

                        // setcol1visible(false);
                        dispatch(contentReducer.col1_visible(false));
                        setaddExtra(false);
                        setadd3DContentfiles(false);
                      }}

                      style={{
                        cursor: "pointer",
  minHeight: "32px",
    minWidth: "32px",
    fontSize: "16px"}}
                    >
                      ←
                    </div>
                    {/* px-2 pt-2 pb-1 */}
                    <div className=" border-secondary border-opacity-25 border-start">
                      <h5>
                        <strong className="ms-3">View AR Content</strong>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-9"></div>
              </div>
              {/* first row */}
              <div
                className="row pt-1"
                style={{
                  paddingBottom: "0px",
                  backgroundColor: "#e6f2f7",
                  // backgroundColor: "red",

                  // height: "9%",
                }}
              >
                {/* <div className="col">
                  <div className="p-2">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                       
                        {showBy === "Product"
                          ? bu_viewcontent
                          : "Business Unit"}
                     
                      </InputLabel>
                      <Select
                        labelid="bu-label"
                        label="Business Unit"
                        size="small"
                        variant="outlined"
                        required
                        disabled={failDisable}
                        
                        onChange={(e) => {
                          dispatch(contentReducer.division_edit(true));
                          let val = e.target.value;
                          DivData(val);
                          fetchProductID(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem key={index} value={item.te_buid}>
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div> */}
                {/* <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                       
                        {showBy === "Product"
                          ? division_viewcontent
                          : "Division"}
                     
                      </InputLabel>
                      <Select
                        labelid="bu-label"
                        size="small"
                        variant="outlined"
                        label="Division"
                        onChange={(e) => {
                          dispatch(contentReducer.product_edit(true));
                          let val = e.target.value;
                          console.log("div name", val);
                          fetchProductID(val);
                        }}
                        disabled={
                          !failDisable ? (division_edit ? false : true) : true
                        }
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem key={index} value={item.te_divisionid}>
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div> */}
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        {showBy === "Product" ? product_viewcontent : "Product"}
                      </InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Product"
                        variant="outlined"
                        size="small"
                        onChange={async (e) => {
                          let val = e.target.value;
                          setShowhide1(val);
                          setProductID(val);
                          setShowhide1(showhide1);
                          // setcol1visible(true);
                          dispatch(contentReducer.col1_visible(true));
                          tableupdate(val);
                        }}
                        // disabled={
                        //   !failDisable ? (product_edit ? false : true) : true
                        // }
                      >
                        {productData.map((item, index) => (
                          <MenuItem key={index} value={item.te_productid}>
                            {item.te_productname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="d-flex flex-row mt-2">
                    <div className="p-0">
                      <Checkbox
                        {...label}
                        id="isDelete"
                        value={isDelete}
                        disabled={
                          !failDisable ? (content_btn ? false : true) : true
                        }
                        onChange={(e) => {
                          setisDelete(e.target.checked);
                          // setaddExtra(e.target.checked);
                        }}
                      />
                      <strong
                        style={{ whiteSpace: "nowrap", color: "#74828F" }}
                      >
                        <span
                          disabled={
                            !failDisable ? (content_btn ? false : true) : true
                          }
                        >
                          is Deleted
                        </span>
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-1 ">
                    {add3DContent ? (
                      <button
                        className="btn btn-light text-white mt-1"
                        style={{
                          backgroundColor: "var(--themes-color)",
                        }}
                        disabled={
                          !failDisable ? (content_btn ? false : true) : true
                        }
                        onClick={() => {
                          if (add3DCinView) {
                            threeDFormData.set("file", file3D);
                            threeDFormData.set(
                              "productid",
                              showBy === "Product" ? productId_View : productID
                            );
                            threeDFormData.set("ostype", osType);
                            threeDFormData.set("status", "1");
                            threeDFormData.set("contentfilename", file3Dname);
                            axios
                              .post(
                                `threedcontent/add`,
                                threeDFormData,
                                options
                              )
                              .then((res) => {
                                if (res.status === 200) {
                                  setAdd3DCinView(false);
                                  threeDFormData.delete("file");
                                  threeDFormData.delete("productid");
                                  threeDFormData.delete("ostype");
                                  threeDFormData.delete("status");
                                  threeDFormData.delete("contentfilename");
                                  dispatch(sidebarReducer.success(true));

                                  dispatch(
                                    sidebarReducer.stringUpdate("ListContent")
                                  );
                                  resetAddContent();
                                  setcolvisible(false);
                                  // setcol1visible(false);
                                  dispatch(contentReducer.col1_visible(false));
                                  dispatch(
                                    sidebarReducer.stringUpdate("ListContent")
                                  );
                                  resetAddContent1();
                                  setisDelete(false);
                                  setcolvisible(false);
                                  setAdd3DCinView(false);
                                  threeDFormData = new FormData();

                                  // setcol1visible(false);
                                  dispatch(contentReducer.col1_visible(false));
                                  setaddExtra(false);
                                  setadd3DContentfiles(false);
                                }
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          } else {
                            dispatch(contentReducer.col1_visible(true));
                            setadd3DContentfiles(true);
                            setAdd3DCinView(true);
                          }
                        }}
                      >
                        {!add3DCinView ? `Add 3D Content` : `submit`}
                      </button>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>
              {
                // col1visible &&
                col1_visible ? (
                  <div
                    className="row shadow"
                    style={{
                      paddingBottom: "2px",
                      minWidth: "77px",
                      backgroundColor: "#e6f2f7",
                      // backgroundColor: "yellow",
                      height: "10vh",
                    }}
                  >
                    <div className="col-4" style={{ paddingLeft: "7px" }}>
                      <div className="p-2 ">
                        {addExtra ? (
                          <ul style={{ paddingLeft: "5px" }}>
                            {addExtra && (
                              <TextField
                                fullWidth
                                id="outlined-basic"
                                label="File Name"
                                variant="outlined"
                                size="small"
                                disabled={Edit3D ? false : true}
                                value={file3Dname}
                                // disabled={content_edit ? false : true}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  setFile3DName(val);
                                }}
                              />
                            )}
                          </ul>
                        ) : (
                          <div></div>
                        )}
                        {add3DContentfiles ? (
                          <ul style={{ paddingLeft: "5px" }}>
                            <input
                              type="file"
                              className="form-control"
                              id="formGroupExampleInput"
                              style={{ width: "100%" }}
                              placeholder="contentName"
                              disabled={failDisable}
                              onChange={(e) => {
                                change3DFile(e);
                              }}
                            />

                            {threeDcorrectFile && (
                              <div className="pt-2 text-danger">
                                *Upload the correct file.
                              </div>
                            )}
                          </ul>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="col-4" style={{ paddingLeft: "0px" }}>
                      <div className="p-2  ">
                        {addExtra ? (
                          <ul style={{ paddingLeft: "0px" }}>
                            {addExtra && (
                              <TextField
                                fullWidth
                                labelid="Content-Status"
                                id="demo-simple-select"
                                label="osType"
                                size="small"
                                variant="outlined"
                                disabled={Edit3D ? false : true}
                                value={osType}
                                // value={EcontentStatus}
                                // disabled={content_edit ? false : true}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  setOsType(val);
                                  setEcontentStatus(val);
                                }}
                              />
                            )}
                          </ul>
                        ) : (
                          <div></div>
                        )}

                        {add3DContentfiles ? (
                          <ul style={{ paddingLeft: "0px" }}>
                            {add3DContentfiles && (
                              <TextField
                                fullWidth
                                id="outlined-basic"
                                label="File Name"
                                variant="outlined"
                                size="small"
                                onChange={(e) => {
                                  setFile3DName(e.target.value);
                                }}
                              />
                            )}
                          </ul>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    {/* Edit and delete */}
                    <div className="col-4" style={{ paddingLeft: "0px" }}>
                      <div className="p-1  ">
                        {addExtra ? (
                          <div
                            className="p-0 "
                            style={{
                              position: "absolute",
                              top: "100px",
                              right: "8px",
                            }}
                          >
                            <button
                              className="btn btn-light text-white mt-1"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                height: "40px",
                                width: "85px",
                              }}
                              onClick={() => {
                                handleReset1();
                                setedit3DPopUp(true);
                                on3DEdit(content_3Did);

                                // setEdit3D(true);
                              }}
                            >
                              Edit
                            </button>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {add3DContentfiles ? (
                          <FormControl
                            sx={{
                              width: "99%",
                            }}
                          >
                            <InputLabel id="Content-Status" size="small">
                              osType
                            </InputLabel>
                            <Select
                              labelid="Content-Status"
                              id="demo-simple-select"
                              label="Inactiv"
                              size="small"
                              variant="outlined"
                              disabled={failDisable}
                              // value={EcontentStatus}
                              // disabled={content_edit ? false : true}
                              onChange={(e) => {
                                let val = e.target.value;
                                setOsType(val);
                                setEcontentStatus(val);
                              }}
                            >
                              <MenuItem value="ios">IoS</MenuItem>
                              <MenuItem value="android">Android</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="row shadow"
                    style={{
                      paddingBottom: "2px",
                      minWidth: "77px",
                      backgroundColor: "#e6f2f7",
                      // backgroundColor: "yellow",
                      height: "2vh",
                    }}
                  ></div>
                )
              }
              {/* second row */}

              <div
                className="row"
                style={{
                  height: "63%",
                  overflowY: "auto",
                  position: "fixed",
                  width: "100%",
                  // bottom: "0px",
                }}
              >
                {/* paper 1 test */}
              </div>

              <div
                className="row "
                style={{
                  height: "70vh",
                  overflowY: "auto",
                  position: "fixed",
                  width: "100%",

                  // bottom: "0px",
                }}
              >
                <div
                  className="col g-0"
                  style={{
                    // backgroundColor: "#E6F2F7",
                    marginBottom: "30px",
                  }}
                >
                  {content_btn ? (
                    <table
                      // stickyHeader
                      className="table table-hover border-top-0 mb-2"
                      ref={ref}
                      style={{
                        overflowX: "auto",
                      }}
                    >
                      <thead
                        className="border-bottom border-secondary shadow"
                        style={{
                          backgroundColor: "#E6F2F7",
                          position: "sticky",
                          top: "0px",
                        }}
                      >
                        <tr style={{ textAlign: "left" }} e="true">
                          <th className="border">Content Name</th>
                          <th className="border">Content Tag</th>
                          <th className="border">Content Filename</th>
                          <th className="border">Content Description</th>
                          <th className="border">Content Type</th>
                          <th className="border">Content Format</th>
                          <th className="border">Actions</th>
                        </tr>
                      </thead>
                      <tbody
                        style={{
                          textAlign: "left",
                          backgroundColor: "#fff",
                          borderCollapse: "separate",
                          borderSpacing: "0 15px",
                        }}
                      >
                        {contentData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={9}
                              className=" border text-center mb-0"
                            >
                              NO DATA FOUND
                            </td>
                          </tr>
                        ) : (
                          //                   viewContentTable.map((item, index) => {

                          //                     if (item.te_isdeleted === "0" || (isDelete === true && item.te_isdeleted === "1")) {
                          //                       return (
                          //                                                    <tr
                          //                         key={index}
                          //                         style={{
                          //                           cursor: "pointer",
                          //                           backgroundColor: `${
                          //                             item.te_isdeleted === "0"
                          //                               ? " #ffffff"
                          //                               : "rgb(195, 198, 205)"
                          //                           }`,
                          //                         }}
                          //                       >
                          //                         <td
                          //                           className="border text-start"
                          //                           onClick={() => {
                          //                             item.te_isdeleted === "0" &&
                          //                               viewContentFunction(item);
                          //                           }}
                          //                         >
                          //                           <img
                          //                             style={{
                          //                               height: "20px",
                          //                               width: "20px",
                          //                               // borderRadius: "25px",
                          //                             }}
                          //                             src={
                          //                               item.te_contentformat === "png"
                          //                                 ? require("../../images/png1.png")
                          //                                 : item.te_contentformat === "jpg"
                          //                                 ? require("../../images/jpg1.png")
                          //                                 : item.te_contentformat === "pdf"
                          //                                 ? require("../../images/pdf1.png")
                          //                                 : item.te_contentformat === "gif"
                          //                                 ? require("../../images/gif1.png")
                          //                                 : item.te_contentformat === "jpeg"
                          //                                 ? require("../../images/jpeg1.png")
                          //                                 : item.te_contentformat === "mp4"
                          //                                 ? require("../../images/mp41.png")
                          //                                 : item.te_contentformat === "txt"
                          //                                 ? require("../../images/txt1.png")
                          //                                 : item.te_contentformat === "docx"
                          //                                 ? require("../../images/doc1.png")
                          //                                 : item.te_contentformat === "mp3"
                          //                                 ? require("../../images/mp31.png")
                          //                                 : item.te_contentformat === "mov"
                          //                                 ? require("../../images/mov.png")
                          //                                 : null
                          //                             }
                          //                             alt="C_LOGO"
                          //                             // onClick={() => {
                          //                             //   setViewContentPopUp(true);
                          //                             // }}
                          //                           />
                          //                           &nbsp;&nbsp;
                          //                           {item.te_contentname}
                          //                         </td>
                          //                         <td
                          //                           className="border text-start"
                          //                           onClick={() => {
                          //                             item.te_isdeleted === "0" &&
                          //                               viewContentFunction(item);
                          //                           }}
                          //                         >
                          //                           {item.te_contenttag}
                          //                         </td>
                          //                         {/* <td className="border text-start">
                          //                     {item.te_contenttype}
                          //                      </td> */}
                          //                         <td
                          //                           className="border text-start"
                          //                           onClick={() => {
                          //                             item.te_isdeleted === "0" &&
                          //                               viewContentFunction(item);
                          //                           }}
                          //                         >
                          //                           {item.te_contentfilename}
                          //                         </td>
                          //                         {/* <td className="border text-start">
                          //   {item.te_contentformat}
                          // </td> */}
                          //                         <td
                          //                           className="border text-start"
                          //                           onClick={() => {
                          //                             item.te_isdeleted === "0" &&
                          //                               viewContentFunction(item);
                          //                           }}
                          //                         >
                          //                           {item.te_contentdescription}
                          //                         </td>

                          //                         <td
                          //                           className="border text-start"
                          //                           onClick={() => {
                          //                             item.te_isdeleted === "0" &&
                          //                               viewContentFunction(item);
                          //                           }}
                          //                         >
                          //                           {item.te_contenttype}
                          //                         </td>

                          //                         <td
                          //                           className="border text-start"
                          //                           onClick={() => {
                          //                             item.te_isdeleted === "0" &&
                          //                               viewContentFunction(item);
                          //                           }}
                          //                         >
                          //                           {item.te_contentformat}
                          //                         </td>

                          //                         <td className="border text-start">
                          //                           <i
                          //                             className="bi bi-pencil-square"
                          //                             style={{ cursor: "pointer" }}
                          //                             onClick={() => {
                          //                               onEdit(item);
                          //                               item.te_isdeleted === "0" &&
                          //                                 seteditPopUp(true);
                          //                             }}
                          //                           ></i>
                          //                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          //                           <i
                          //                             className="bi bi-archive-fill"
                          //                             style={{ cursor: "pointer" }}
                          //                             onClick={() => {
                          //                               item.te_isdeleted === "0" &&
                          //                                 setdeletepopUp(true);
                          //                               setEcontentID(item.te_contentid);
                          //                             }}
                          //                           ></i>
                          //                         </td>
                          //                       </tr>
                          //                       );
                          //                     }
                          //                     // If the item doesn't meet the conditions, don't render anything
                          //                     return null;
                          //                   })
                          viewContentTable.map((item, index) => {
                            return item.te_isdeleted === "0" ||
                              (isDelete === true &&
                                item.te_isdeleted === "1") ? (
                              <tr
                                key={index}
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: `${
                                    item.te_isdeleted === "0"
                                      ? " #ffffff"
                                      : "rgb(195, 198, 205)"
                                  }`,
                                }}
                              >
                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    item.te_isdeleted === "0" &&
                                      viewContentFunction(item);
                                    console.log("item", item);
                                  }}
                                >
                                  <img
                                    style={{
                                      height: "20px",
                                      width: "20px",
                                      // borderRadius: "25px",
                                    }}
                                    src={
                                      item.te_contentformat === "png"
                                        ? require("../../images/png1.png")
                                        : item.te_contentformat === "jpg"
                                        ? require("../../images/jpg1.png")
                                        : item.te_contentformat === "pdf"
                                        ? require("../../images/pdf1.png")
                                        : item.te_contentformat === "gif"
                                        ? require("../../images/gif1.png")
                                        : item.te_contentformat === "jpeg"
                                        ? require("../../images/jpeg1.png")
                                        : item.te_contentformat === "mp4"
                                        ? require("../../images/mp41.png")
                                        : item.te_contentformat === "txt"
                                        ? require("../../images/txt1.png")
                                        : item.te_contentformat === "docx"
                                        ? require("../../images/doc1.png")
                                        : item.te_contentformat === "mp3"
                                        ? require("../../images/mp31.png")
                                        : item.te_contentformat === "mov"
                                        ? require("../../images/mov.png")
                                        : null
                                    }
                                    alt="C_LOGO"
                                    // onClick={() => {
                                    //   setViewContentPopUp(true);
                                    // }}
                                  />
                                  &nbsp;&nbsp;
                                  {item.te_contentname}
                                </td>
                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    item.te_isdeleted === "0" &&
                                      viewContentFunction(item);
                                    console.log("item", item);
                                  }}
                                >
                                  {item.te_contenttag}
                                </td>
                                {/* <td className="border text-start">
                            {item.te_contenttype}
                             </td> */}
                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    item.te_isdeleted === "0" &&
                                      viewContentFunction(item);
                                    console.log("item", item);
                                  }}
                                >
                                  {item.te_contentfilename}
                                </td>
                                {/* <td className="border text-start">
          {item.te_contentformat}
        </td> */}
                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    item.te_isdeleted === "0" &&
                                      viewContentFunction(item);
                                    console.log("item", item);
                                  }}
                                >
                                  {item.te_contentdescription}
                                </td>

                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    item.te_isdeleted === "0" &&
                                      viewContentFunction(item);
                                  }}
                                >
                                  {item.te_contenttype}
                                </td>

                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    item.te_isdeleted === "0" &&
                                      viewContentFunction(item);
                                  }}
                                >
                                  {item.te_contentformat}
                                </td>

                                <td className="border text-start">
                                  {/* <i
                                    className="bi bi-pencil-square"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      onEdit(item);
                                      item.te_isdeleted === "0" &&
                                        seteditPopUp(true);
                                    }}
                                  ></i> */}
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  <i
                                    className="bi bi-archive-fill"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      item.te_isdeleted === "0" &&
                                        setdeletepopUp(true);
                                      setEcontentID(item.te_contentid);
                                    }}
                                  ></i>
                                </td>
                              </tr>
                            ) : (
                              <tr></tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
          </SlidingPane>

          {/** SlidingPan pop up for add content data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="75%"
            hideHeader
            isOpen={addcontent_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              //  onCancel();
            }}
          >
            <div className="container-fluid " style={{ height: "100%" }}>
              <div
                className="row p-0 align-items-center border"
                style={{ height: "5%", backgroundColor: "#e6f2f7", border: "none" }}
              >
                <div className="col-3">
                  <div className="d-flex align-items-center flex-row">
                  <div
  className="px-2 my-1 d-flex align-items-center justify-content-center"
  onClick={() => {
    if (isSubmitting) return;
    dispatch(sidebarReducer.stringUpdate("ListContent"));
    resetAddContent();
    setcolvisible(false);
    dispatch(contentReducer.col1_visible(false));
  }}
  style={{
    cursor: isSubmitting ? "not-allowed" : "pointer",
    opacity: isSubmitting ? 0.6 : 1,
    pointerEvents: isSubmitting ? "none" : "auto",
    minHeight: "32px",
    minWidth: "32px",
    fontSize: "16px",
  }}
>
 ←
</div>
                    <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                      <h5>
                        <strong>Add AR Content</strong>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-9"></div>
              </div>
              {/* first row */}
              <div
                className="row "
                style={{
                  paddingBottom: "0px",
                  backgroundColor: "#e6f2f7",
                }}
              >
                {/* <div className="col">
                  <div className="p-2">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                        Business Unit
                       
                      </InputLabel>
                      <Select
                        labelid="bu-label"
                        label="Business Unit"
                        size="small"
                        variant="outlined"
                        required
                        disabled={failDisable}
                        onChange={(e) => {
                          dispatch(contentReducer.division_edit(true));

                          let val = e.target.value;
                          DivData(val);
                          fetchProductID(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem key={index} value={item.te_buid}>
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div> */}
                {/* <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                        Division
                       
                      </InputLabel>
                      <Select
                        labelid="bu-label"
                        size="small"
                        variant="outlined"
                        label="Division"
                        onChange={(e) => {
                          dispatch(contentReducer.product_edit(true));

                          let val = e.target.value;

                          fetchProductID(val);
                        }}
                        disabled={
                          !failDisable ? (division_edit ? false : true) : true
                        }
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem key={index} value={item.te_divisionid}>
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div> */}
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        Product
                      </InputLabel>
                      <Select
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Product"
                        variant="outlined"
                        size="small"
                        onChange={(e) => {
                          let val = e.target.value;
                          setShowhide1(val);
                          setProductID(val);

                          dispatch(contentReducer.content_btn(true));
                        }}
                        // disabled={
                        //   !failDisable ? (product_edit ? false : true) : true
                        // }
                      >
                        {productData.map((item, index) => (
                          <MenuItem key={index} value={item.te_productid}>
                            {item.te_productname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="d-flex flex-row mt-2">
                    <div className="p-0">
                      <Checkbox
                        {...label}
                        id="addExtra"
                        value={addExtra}
                        // disabled={
                        //   !failDisable ? (content_btn ? false : true) : true
                        // }
                        onChange={(e) => {
                          setcolvisible(true);
                          setaddExtra(e.target.checked);
                        }}
                      />
                    </div>

                    <div className="p-2">
                      <label className="form-check-label" htmlFor="addExtra">
                        <strong style={{ whiteSpace: "nowrap" }}>
                          <span>3D Content</span>
                        </strong>
                      </label>
                    </div>
                    <div className="p-2" style={{ whiteSpace: "nowrap" }}>
                      {api3DStatus === "L" && <div className="spinnerC"></div>}

                      {api3DStatus === "S" && (
                        <div style={{ color: "green" }}>
                          Added Successfully!
                        </div>
                      )}

                      {api3DStatus === "FNE" && (
                        <div style={{ color: "var(--themes-color)" }}>
                          File name already existed!
                        </div>
                      )}

                      {api3DStatus === "PE" && (
                        <div style={{ color: "var(--themes-color)" }}>
                          File is already mapped to Product
                        </div>
                      )}

                      {api3DStatus === "F" && (
                        <div style={{ color: "red" }}>Adding Failed!</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col"></div>
                <div className="col " style={{ paddingRight: "5px" }}>
                  <div
                    className="p-0 "
                    style={{
                      textAlign: "center",
                      minWidth: "60px",
                    }}
                  >
                    <button
                      className="btn  text-white mt-1"
                      style={{
                        backgroundColor: "var(--themes-color)",
                        cursor: isSubmitting ? "not-allowed" : "pointer",
                        opacity: isSubmitting ? 0.6 : 1,
                        pointerEvents: isSubmitting ? "none" : "auto",
                      }}
                      disabled={isSubmitting}
                      // disabled={
                      //   !failDisable ? (content_btn ? false : true) : true
                      // }
                      onClick={() => {
                        if (isSubmitting) return; // Prevent action during submission
                        addFormFields();
                      }}
                    >
                      Add Content
                    </button>
                  </div>
                </div>
              </div>
              {colvisible ? (
                <div
                  className="row border-bottom shadow "
                  style={{
                    paddingBottom: "0px",
                    minWidth: "77px",
                    backgroundColor: "#e6f2f7",
                    height: "62px",
                  }}
                >
                  <div className="col">
                    <div className="p-2">
                      {addExtra ? (
                        <ul style={{ paddingLeft: "0px" }}>
                          {addExtra && (
                            <input
                              type="file"
                              className="form-control"
                              id="formGroupExampleInput"
                              style={{ width: "99%" }}
                              placeholder="contentName"
                              title="Choose a 3D model file. "
                              disabled={failDisable}
                              accept=".obj,.fbx,.glb,.gltf"
                              onChange={(e) => {
                                change3DFile(e);
                              }}
                            />
                          )}
                          {threeDcorrectFile && (
                            <div className="pt-2 text-danger">
                              *Upload the correct file.
                            </div>
                          )}
                        </ul>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="col" style={{ paddingLeft: "0px" }}>
                    <div
                      className=" mt-2"
                      style={{ paddingLeft: "0px!important" }}
                    >
                      {addExtra ? (
                        <ul style={{ paddingLeft: "2px" }}>
                          {addExtra && (
                            <TextField
                              id="outlined-basic"
                              label="File Name"
                              variant="outlined"
                              fullWidth
                              size="small"
                              disabled={failDisable}
                              //value={EcontentFileName}
                              // disabled={content_edit ? false : true}
                              onChange={(e) => {
                                let val = e.target.value;
                                setFile3DName(val);
                                setEcontentFileName(val);
                              }}
                              required
                            />
                          )}
                        </ul>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="col" style={{ paddingLeft: "0px" }}>
                    <div className="p-2 ">
                      {addExtra ? (
                        <FormControl
                          sx={{
                            width: "98%",
                          }}
                        >
                          <InputLabel id="Content-Status" size="small">
                            osType
                          </InputLabel>
                          <Select
                            labelid="Content-Status"
                            id="demo-simple-select"
                            label="Inactiv"
                            size="small"
                            variant="outlined"
                            disabled={failDisable}
                            // value={EcontentStatus}
                            // disabled={content_edit ? false : true}
                            onChange={(e) => {
                              let val = e.target.value;
                              setOsType(val);
                              setEcontentStatus(val);
                            }}
                          >
                            <MenuItem value="ios">IoS</MenuItem>
                            <MenuItem value="android">Android</MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              {/* second row */}
              {/* Paper component */}
              <div
                className="row"
                style={{
                  height: "63%",
                  overflowY: "auto",
                  position: "fixed",
                  width: "100%",
                  // bottom: "0px",
                }}
              >
                <div className="col mb-3">
                  <form style={{ margin: "0 auto" }}>
                    {formValues.map((data, i) => (
                      <div className="form-inline  " key={i}>
                        <Paper className="m-3 " elevation={3}>
                          <div
                            className="d-flex mb-2 justify-content-between"
                            style={{ height: "63%" }}
                          >
                            <div className="ms-2 mt-2">New</div>

                            <div className="">
                              <div className="d-flex">
                                <div className="p-2">
                                  {content1Arr[i] === "L" && (
                                    <div className="spinnerC"></div>
                                  )}
                                  {content1Arr[i] === "FM" && (
                                    <div style={{ color: "red" }}>
                                      Format Mismatch!
                                    </div>
                                  )}
                                  {content1Arr[i] === "S" && (
                                    <div style={{ color: "green" }}>
                                      Added Successfully!
                                    </div>
                                  )}
                                  {content1Arr[i] === "FNE" && (
                                    <div
                                      style={{
                                        color: "var(--themes-color)",
                                      }}
                                    >
                                      File name already existed!
                                    </div>
                                  )}
                                  {content1Arr[i] === "FE" && (
                                    <div
                                      style={{
                                        color: "var(--themes-color)",
                                      }}
                                    >
                                      File already existed!
                                    </div>
                                  )}
                                  {content1Arr[i] === "F" && (
                                    <div style={{ color: "red" }}>
                                      Adding Failed!
                                    </div>
                                  )}
                                </div>
                                <div className="p-2">
                                  {i || i === 0 ? (
                                    <span
                                      onClick={(e) => {
                                        if (!failDisable && !isSubmitting) {
                                          removeFormFields(i);
                                          setdub((num) => num - 1);
                                        }
                                      }}
                                      style={{
                                        cursor:
                                          failDisable || isSubmitting
                                            ? "not-allowed"
                                            : "pointer",
                                        opacity:
                                          failDisable || isSubmitting ? 0.6 : 1,
                                        pointerEvents:
                                          failDisable || isSubmitting
                                            ? "none"
                                            : "auto",
                                      }}
                                    >
                                      <i
                                        className="bi bi-x-circle"
                                        style={{
                                          color:
                                            failDisable || isSubmitting
                                              ? "#ccc"
                                              : "inherit",
                                        }}
                                      ></i>
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 1st row */}
                          <div className="row ">
                            <div className="col ms-2">
                              <div className="col">
                                <TextField
                                  variant="outlined"
                                  type="text"
                                  name="tag"
                                  label="Content Tag No"
                                  fullWidth
                                  size="small"
                                  required
                                  value={CTag[i]}
                                  disabled={failDisable}
                                  onChange={(e) => {
                                    formValues[i].set(
                                      "teContentTag",
                                      e.target.value
                                    );
                                    CTag[i] = e.target.value;
                                    handleChangeTrial(i, e);
                                    // setContentTag(e.target.value);
                                  }}
                                  InputProps={{
                                    sx: {
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        { borderColor: "black" },
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        { borderColor: "black" },
                                    },
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col me-2">
                              <TextField
                                type="text"
                                variant="outlined"
                                name="name"
                                label="Content Name"
                                fullWidth
                                size="small"
                                required
                                value={CName[i]}
                                disabled={failDisable}
                                onChange={(e) => {
                                  formValues[i].set(
                                    "teContentName",
                                    e.target.value
                                  );
                                  CName[i] = e.target.value;
                                  handleChangeTrial(i, e);
                                }}
                                InputProps={{
                                  sx: {
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      { borderColor: "black" },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      { borderColor: "black" },
                                  },
                                }}
                              />
                            </div>
                          </div>
                          {/* 2nd row */}
                          <div className="row mt-2 ">
                            <div className="col ms-2 ">
                              <div className="d-flex justify-content-between">
                                <div className="col ">
                                  <FormControl
                                    sx={{
                                      width: "100%",
                                    }}
                                  >
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      size="small"
                                      required
                                    >
                                      Content Type
                                    </InputLabel>

                                    <Select
                                      labelid="demo-simple-select-filled-label"
                                      id="demo-simple-select-filled"
                                      name="cType"
                                      size="small"
                                      label="Content Type"
                                      variant="outlined"
                                      value={CType[i]}
                                      disabled={failDisable}
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        formValues[i].set(
                                          "teContentType",
                                          e.target.value
                                        );
                                        if (val === "text") {
                                          formValues[i].set(
                                            "teContentFormat",
                                            "txt"
                                          );
                                        }
                                        CMin[i] = "";
                                        CSec[i] = "";
                                        CType[i] = e.target.value;
                                        handleMapping(val);
                                        handleChangeTrial(i, e);
                                      }}
                                    >
                                      <MenuItem
                                        value="image"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = img;
                                          }
                                          showhide[i] = false;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Image
                                      </MenuItem>
                                      <MenuItem
                                        value="audio"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = aud;
                                          }
                                          showhide[i] = true;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Audio
                                      </MenuItem>
                                      <MenuItem
                                        value="video"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = vid;
                                          }
                                          showhide[i] = true;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Video
                                      </MenuItem>
                                      <MenuItem
                                        value="file"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = docs;
                                          }
                                          showhide[i] = false;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Doc
                                      </MenuItem>
                                      <MenuItem
                                        value="text"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = [];
                                          }
                                          showhide[i] = "text";
                                          settextvalidated(true);
                                        }}
                                      >
                                        Text
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                              </div>
                            </div>

                            <div
                              className="col me-2  "
                              onMouseEnter={() => setMapper(fileType[i])}
                            >
                              <FormControl fullWidth>
                                <InputLabel
                                  id="content-format"
                                  size="small"
                                  required
                                >
                                  File Format
                                </InputLabel>
                                <Select
                                  labelid="content-format"
                                  id="demo-simple-select"
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    width: "100%",

                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      { borderColor: "black" }, // Hover border color
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      { borderColor: "black" }, // Focus border color
                                  }}
                                  name="cForm"
                                  label="File Format"
                                  disabled={
                                    failDisable
                                      ? true
                                      : showhide[i] === "text"
                                      ? true
                                      : false
                                  }
                                  value={CFormat[i]}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    setContentForm(contentForm);
                                    setContentForm(val);
                                    formValues[i].set(
                                      "teContentFormat",
                                      e.target.value
                                    );
                                    CFormat[i] = e.target.value;
                                    handleChangeTrial(i, e);
                                    let str = `.${e.target.value}`;
                                    setAccept(str);
                                    if (formValues.length === i) {
                                      setAcceprArr((arr) => [...arr, str]);
                                    } else if (i < formValues.length) {
                                      acceptArr[i] = str;
                                    }
                                  }}
                                >
                                  <MenuItem selected value="">
                                    select format
                                  </MenuItem>
                                  {fileType.length > 0 &&
                                    fileType[i].map((item, index) => (
                                      <MenuItem key={index} value={item}>
                                        {item}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                          {/* 3rd row */}

                          {/* {inter} */}
                          <div className="row mt-2 ">
                            <div className="col ms-2">
                              <TextField
                                id="outlined-multiline-flexible"
                                label="Content Description"
                                multiline
                                // maxRows={4}
                                disabled={failDisable}
                                rows={2}
                                rowsMax={10}
                                variant="outlined"
                                name="Desc"
                                required
                                fullWidth
                                size="small"
                                value={CDescription[i]}
                                onChange={(e) => {
                                  formValues[i].set(
                                    "teContentDescription",
                                    e.target.value
                                  );
                                  CDescription[i] = e.target.value;
                                  let val = e.target.value;

                                  setContentDesc(val);
                                  handleChangeTrial(i, e);
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "&:hover fieldset": {
                                      borderColor: "black",
                                    }, // Border color on hover
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black",
                                    }, // Border color when focused
                                  },
                                }}
                              />
                            </div>

                            <div className="col me-2 ">
                              <FormControl fullWidth>
                                <InputLabel
                                  id="demo-simple-select-label"
                                  size="small"
                                  required
                                >
                                  Status
                                </InputLabel>
                                <Select
                                  labelid="demo-simple-select-filled-label"
                                  id="demo-simple-select-filled"
                                  label="select status"
                                  name="status"
                                  variant="outlined"
                                  size="small"
                                  disabled={failDisable}
                                  value={CStatus[i]}
                                  onChange={(e) => {
                                    formValues[i].set(
                                      "teContentStatus",
                                      e.target.value
                                    );
                                    CStatus[i] = e.target.value;
                                    setdub((num) => num + 1);
                                    console.log(dub);
                                    // setContentStatus(val);
                                    // handleChangeTrial(i, e);
                                  }}
                                >
                                  <MenuItem value="1">Active</MenuItem>
                                  <MenuItem value="0">InActive</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                          {/* 4rth */}

                          {/* 6th row */}

                          <div className="row">
                            <div className="col ms-2 mt-0">
                              {CType[i] === "text" && (
                                <div className="row">
                                  <div className="col ">
                                    <TextField
                                      id="outlined-multiline-flexible"
                                      label="Enter Text"
                                      multiline
                                      // maxRows={4}
                                      rows={2}
                                      rowsMax={10}
                                      variant="outlined"
                                      name="text"
                                      fullWidth
                                      size="small"
                                      value={CText[i]}
                                      disabled={
                                        failDisable
                                          ? true
                                          : textvalidated
                                          ? false
                                          : true
                                      }
                                      onChange={(e) => {
                                        formValues[i].set(
                                          "teContentText",
                                          e.target.value
                                        );
                                        let val = e.target.value;
                                        CText[i] = val;
                                        settextvalidated(val);
                                        handleChangeTrial(i, e);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              {(CType[i] === "image" ||
                                CType[i] === "audio" ||
                                CType[i] === "video" ||
                                CType[i] === "file") && (
                                <div className=" row ms-2 mt-0 ">
                                  {/* <div className="col-3"> */}
                                  <FormControl>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="row-radio-buttons-group"
                                    >
                                      <FormControlLabel
                                        control={<Radio />}
                                        label="URL"
                                        checked={
                                          fileRurl[i] === "URL" ? true : false
                                        }
                                        value="URL"
                                        name="urlOrFile"
                                        disabled={failDisable}
                                        onChange={(e) => {
                                          if (i < formValues.length) {
                                            fileRurl[i] = e.target.value;
                                            console.log(
                                              "file_array",
                                              fileRurl[i]
                                            );
                                          } //formValues[i].append("teContenttext",e.target.value);
                                          formValues[i].set(
                                            "teContentFileName",
                                            "url_file_name"
                                          );
                                          formValues[i].delete("content");
                                          handleChangeTrial(i, e);
                                          // setisfileformat(true);
                                        }}
                                      />
                                      <FormControlLabel
                                        control={<Radio />}
                                        label="File"
                                        id="file"
                                        name="urlOrFile"
                                        checked={
                                          fileRurl[i] === "File" ? true : false
                                        }
                                        disabled={failDisable}
                                        // ref={fileRef}
                                        // checked={data.urlOrFile === "File"}
                                        onChange={(e) => {
                                          if (i < formValues.length) {
                                            fileRurl[i] = e.target.value;
                                          }
                                          handleChangeTrial(i, e);
                                          // setisfileformat(false);
                                        }}
                                        value="File"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </div>
                              )}

                              {/* </div> */}

                              <div></div>
                            </div>
                            <div
                              className="col me-2 "
                              // onMouseEnter={() => setMapper(fileType[i])}
                            >
                              {fileRurl[i] === "URL" && (
                                <TextField
                                  id="outlined-basic"
                                  style={{ marginTop: "5px" }}
                                  label="URL"
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  value={CUrl[i]}
                                  disabled={failDisable}
                                  onChange={(e) => {
                                    // let val = e.target.value;
                                    formValues[i].set(
                                      "teContentUrl",
                                      e.target.value
                                    );
                                    CUrl[i] = e.target.value;
                                    // setURLvalidated(val);
                                    handleChangeTrial(i, e);
                                  }}
                                />
                              )}
                              {fileRurl[i] === "File" && (
                                // showhide != "text" &&
                                <div
                                  onMouseEnter={() => setAccept(acceptArr[i])}
                                >
                                  <input
                                    type="file"
                                    className="form-control"
                                    id="formGroupExampleInput"
                                    style={{ marginTop: "5px" }}
                                    placeholder="contentName"
                                    disabled={failDisable}
                                    accept={accept}
                                    onChange={(e) => {
                                      let val = e.target.files[0];
                                      formValues[i].set("content", val);
                                      formValues[i].set(
                                        "teContentFileName",
                                        val.name
                                      );
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </Paper>
                      </div>
                    ))}
                  </form>
                </div>
              </div>
              <div
                className="row"
                style={{
                  backgroundColor: "#E3E3E3",
                  position: "fixed",
                  bottom: "28px",
                  width: "100%",
                }}
              >
                <div className="d-flex justify content start">
                  {(formValues.length > 0 || addExtra === true) && (
                    <button
                      type="submit"
                      className="btn btn-light text-white mb-2 mt-0"
                      style={{
                        backgroundColor: "var(--themes-color)",
                        cursor:
                          isSubmitting || threeDcorrectFile
                            ? "not-allowed"
                            : "pointer",
                        opacity: isSubmitting || threeDcorrectFile ? 0.6 : 1,
                        pointerEvents:
                          isSubmitting || threeDcorrectFile ? "none" : "auto",
                      }}
                      onClick={(e) => {
                        if (isSubmitting) return; // Prevent click when submitting
                        failDisable ? resetAddContent() : onSubmit3D(e);
                      }}
                      disabled={threeDcorrectFile || isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        <>&nbsp;{failDisable ? "Close" : "Submit"}</>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/* </div> */}
          </SlidingPane>
          <Modal
            open={popUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="d-flex align-items-center justify-content-center flex-column">
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6 className="text-success">{successMsg}</h6>
                  <h6 className="" style={{ color: "var(--themes-color)" }}>
                    {existMsg}
                  </h6>
                  <h6 className="text-danger">{failMsg}</h6>
                  {/* Add format mismatch message */}
                  <h6 className="text-danger">{formatMismatchMsg}</h6>
                </div>
                <div className="pt-4">
                  <button
                    type="button"
                    className="btn text-white"
                    style={{
                      backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() => {
                      // Check if there's a format mismatch message
                      if (formatMismatchMsg) {
                        // Only close the popup, don't close sidebar or reset content
                        setPopUp(false);
                        setFormatMismatchMsg("");

                        // Reset format mismatch status for all items
                        const resetStates = [...content1Arr];
                        resetStates.forEach((state, index) => {
                          if (state === "FM") {
                            resetStates[index] = "";
                          }
                        });
                        setContent1Arr(resetStates);

                        // Don't call resetAddContent() or failAddCase() - keep sidebar open
                        return;
                      }

                      // Original logic for other cases
                      setFormatMismatchMsg("");

                      if (existCountState === 0 && failCountState === 0) {
                        resetAddContent();
                      } else {
                        failAddCase();
                      }
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={editpopUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              {Edit_Permission === 1 ? (
                <div>
                  <div className="d-flex align-items-center mb-2 justify-content-between">
                    <div>
                      <h5>
                        <strong
                          style={{
                            position: "absolute",
                            top: "5px",
                            left: "15px",
                          }}
                        >
                          Edit
                        </strong>
                      </h5>
                    </div>

                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "15px",
                      }}
                    >
                      <span onClick={onCancel}>
                        <i className="bi bi-x-circle  "></i>
                      </span>
                    </div>
                  </div>
                  <center>
                    <div>
                      <Paper
                        elevation={3}
                        style={{
                          marginTop: "12px",
                        }}
                      >
                        <div className="row ">
                          <div className="col ms-2 ">
                            <div className="col mt-2">
                              <TextField
                                variant="outlined"
                                type="text"
                                name="tag"
                                label="Content Tag No"
                                fullWidth
                                size="small"
                                // required
                                value={EcontentTag}
                                disabled={editdisable ? true : false}
                                onChange={(e) => {
                                  setEcontentTag(e.target.value);
                                }}
                                InputProps={{
                                  sx: {
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      { borderColor: "black" },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      { borderColor: "black" },
                                  },
                                }}
                              />
                            </div>
                          </div>

                          <div className="col me-2 mt-2">
                            <TextField
                              type="text"
                              variant="outlined"
                              name="name"
                              label="Content Name"
                              fullWidth
                              size="small"
                              disabled={editdisable ? true : false}
                              value={EcontentName}
                              onChange={(e) => {
                                setEcontentName(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mt-2 ">
                          <div className="col ms-2">
                            <TextField
                              id="outlined-multiline-flexible"
                              label="Content Description"
                              multiline
                              disabled={editdisable ? true : false}
                              rows={2}
                              rowsMax={10}
                              variant="outlined"
                              name="Desc"
                              fullWidth
                              size="small"
                              value={EcontentDesc}
                              onChange={(e) => {
                                setEcontentDesc(e.target.value);
                              }}
                            />
                          </div>

                          <div className="col me-2 ">
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                              >
                                Content Format
                              </InputLabel>

                              <Select
                                labelid="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                name="cType"
                                size="small"
                                label="Content format"
                                value={EcontentFormat}
                                variant="outlined"
                                disabled={editdisable ? false : true}
                                onChange={(e) => {
                                  let val = e.target.value;

                                  setEcontentFormat(val);
                                }}
                              >
                                <MenuItem value={EcontentFormat}>
                                  {EcontentFormat}
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className="row mt-2 ">
                          <div className="col ms-2">
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                              >
                                Content Type
                              </InputLabel>

                              <Select
                                labelid="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                name="cType"
                                size="small"
                                label="Content Type"
                                value={EcontentType}
                                variant="outlined"
                                disabled={editdisable ? false : true}
                                onChange={(e) => {
                                  let val = e.target.value;

                                  setEcontentType(val);
                                }}
                              >
                                <MenuItem value="image">Image</MenuItem>
                                <MenuItem value="audio">Audio</MenuItem>
                                <MenuItem value="video">Video</MenuItem>
                                <MenuItem value="file">Doc</MenuItem>
                                <MenuItem value="text">Text</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col me-2">
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                              >
                                Status
                              </InputLabel>
                              <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                name="cStatus"
                                size="small"
                                label="Status"
                                value={EcontentStatus}
                                disabled={editdisable ? true : false}
                                variant="outlined"
                                onChange={(e) => {
                                  let val = e.target.value;
                                  setEcontentStatus(val);
                                }}
                              >
                                <MenuItem value="1">Active</MenuItem>
                                <MenuItem value="0">Inactive</MenuItem>
                              </Select>
                            </FormControl>
                            {/* <div className="col "> */}
                          </div>
                        </div>
                      </Paper>

                      <Grid className="mt-4">
                        <button
                          type="button"
                          className="btn text-white"
                          style={{
                            backgroundColor: "var(--themes-color)",
                            width: "100px",
                            position: "absolute",
                            top: "250px",
                            left: "170px",
                          }}
                          onClick={onCancel}
                        >
                          Cancel
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          className="btn text-white"
                          style={{
                            backgroundColor: "var(--themes-color)",
                            width: "128px",
                            position: "absolute",
                            top: "250px",
                          }}
                          onClick={() => {
                            // onUpdate(content_id);
                            seteditPopUp(false);
                            onUpdate(content_id);
                          }}
                        >
                          Save Changes
                        </button>
                      </Grid>
                    </div>
                  </center>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <center>
                    <div className="p-2">
                      <h6 className="text-danger">
                        You have no permission to edit this content.
                      </h6>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn text-white"
                        style={{
                          backgroundColor: "var(--themes-color)",
                          width: "100px",
                        }}
                        onClick={onCancel}
                      >
                        Close
                      </button>
                    </div>
                  </center>
                </div>
              )}
            </Box>
          </Modal>
          <Modal
            open={deletepopUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              {Delete_Permission === 1 ? (
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <div
                    style={{
                      overflowY: "auto",
                    }}
                  >
                    <h6>Are you sure you want to delete this Content?</h6>
                  </div>

                  <div className="pt-4">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        onDelete(EcontentID);
                      }}
                    >
                      Delete
                    </button>
                    &nbsp; &nbsp; &nbsp;
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        setdeletepopUp(false);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <center>
                    <div className="p-2">
                      <h6 className="text-danger">
                        You have no permission to delete this content.
                      </h6>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn text-white"
                        style={{
                          backgroundColor: "var(--themes-color)",
                          width: "90px",
                        }}
                        onClick={() => {
                          setdeletepopUp(false);
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </center>
                </div>
              )}
            </Box>
          </Modal>
          {/* View content page */}

          <Modal
            open={edit3DpopUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{ padding: "15px !important" }}
          >
            <Box sx={style}>
              <center>
                <div
                  className="d-flex mb-2 justify-content-between"
                  // style={{ height: "20%" }}
                >
                  <div>
                    <h5>
                      <strong
                        style={{
                          position: "absolute",
                          top: "5px",
                          left: "15px",
                        }}
                      >
                        Edit
                      </strong>
                    </h5>
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "15px",
                    }}
                  >
                    <span onClick={onCancel}>
                      <i className="bi bi-x-circle  "></i>
                    </span>
                  </div>
                </div>
                <div>
                  <Paper
                    elevation={3}
                    style={{
                      marginTop: "30px",
                    }}
                  >
                    <div className="row "></div>

                    <div
                      className="row"
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      <div className="col ms-2 mt-2">
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          label="File Name"
                          variant="outlined"
                          size="small"
                          // disabled={Edit3D ? false : true}
                          value={Econtent3Dfilename}
                          // disabled={content_edit ? false : true}
                          onChange={(e) => {
                            let val = e.target.value;
                            setEcontent3Dfilename(val);
                          }}
                        />
                        {/* <div className="col "> */}
                      </div>
                      <div className="col me-2 mt-2">
                        <FormControl
                          fullWidth
                          sx={{
                            width: "97%",
                          }}
                          onChange={(e) => {
                            let val = e.target.value;
                            setOsType(val);
                            setEcontentStatus(val);
                          }}
                        >
                          <InputLabel id="Content-Status" size="small">
                            osType
                          </InputLabel>
                          <Select
                            labelid="Content-Status"
                            id="demo-simple-select"
                            label="Inactiv"
                            size="small"
                            variant="outlined"
                            // disabled={Edit3D ? false : true}
                            value={Econtent3DOs}
                            // value={EcontentStatus}
                            // disabled={content_edit ? false : true}
                            onChange={(e) => {
                              let val = e.target.value;
                              setEcontent3DOs(val);
                              setEcontentStatus(val);
                            }}
                          >
                            <MenuItem value="ios">IoS</MenuItem>
                            <MenuItem value="android">Android</MenuItem>
                          </Select>
                        </FormControl>
                        {/* <div className="col "> */}
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col ms-2 ">
                        <div className="col ">
                          <ul style={{ paddingLeft: "0px" }}>
                            <input
                              type="file"
                              className="form-control"
                              id="formGroupExampleInput"
                              style={{ width: "100%" }}
                              placeholder="contentName"
                              // disabled={failDisable}
                              onChange={(e) => {
                                change3DFile(e);
                              }}
                            />

                            {threeDcorrectFile && (
                              <div className="pt-2 text-danger">
                                *Upload the correct file.
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>

                      <div className="col me-2 "></div>
                    </div>
                  </Paper>
                  <Grid className="mt-4">
                    <button
                      type="button"
                      className="btn text-white"
                      style={{
                        backgroundColor: "var(--themes-color)",
                        width: "100px",
                        position: "absolute",
                        top: "232px",
                        left: "170px",
                      }}
                      onClick={onCancel}
                    >
                      Cancel
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn text-white"
                      style={{
                        backgroundColor: "var(--themes-color)",
                        width: "128px",
                        position: "absolute",
                        top: "232px",
                      }}
                      onClick={() => {
                        // onUpdate(content_id);
                        setedit3DPopUp(false);
                        // on3DUpdate(content_3Did);
                        on3DUpdate(content_3Did);
                      }}
                    >
                      Save Changes
                    </button>
                  </Grid>
                </div>
              </center>
            </Box>
          </Modal>

          <Modal
            open={viewContentPopUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box style={viewContentPopUpStyle}>
              <div
                className="d-flex justify-content-end"
                style={{ height: "50px" }}
              >
                <button
                  className="btn btn-danger m-1 p-2"
                  onClick={() => setViewContentPopUp(false)}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div
                className="border m-2"
                style={{ height: "80vh", overflowY: "auto" }}
              >
                <div className="m-2">
                  {contentPopUpType === "image" && (
                    <div>
                      <h3 className="my-2 ps-2">
                        <strong>
                          {viewContentPopUpDetails.te_contentname}
                        </strong>
                      </h3>
                      <div className="d-flex">
                        <div className="p-2">
                          <img
                            src={contentPopUpSrc}
                            alt={defaultUrl}
                            height="600px"
                            width="800px"
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <div className="p-2">
                          <div className="my-4">
                            <ul className="viewContentLi">
                              <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_productname}`}</li>
                              <li className="my-3">
                                {viewContentPopUpDetails.te_contentdescription}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {contentPopUpType === "video" && (
                    <div>
                      <h3 className="my-2 ps-2">
                        <strong>
                          {viewContentPopUpDetails.te_contentname}
                        </strong>
                      </h3>
                      <div className="d-flex">
                        <div className="p-2">
                          <video
                            className="border"
                            controls
                            width="900"
                            height="450"
                          >
                            <source
                              src={contentPopUpSrc}
                              // type={`video/${contentPopUpFormat}`}
                            />
                            Sorry, your browser doesn't support videos.
                          </video>
                        </div>
                        <div className="p-2 ">
                          <div className="my-2">
                            <ul className="viewContentLi">
                              <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_productname}`}</li>
                              <li className="my-3">
                                {viewContentPopUpDetails.te_contentdescription}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {contentPopUpType === "audio" && (
                    <div
                      style={{
                        height: "80vh",

                        // paddingLeft: "43%",
                      }}
                    >
                      <div
                        className="ms-3"
                        style={{ paddingTop: "5%", marginBottom: "2%" }}
                      >
                        <h3>
                          <strong>
                            {viewContentPopUpDetails.te_contentname}
                          </strong>
                        </h3>
                      </div>
                      <audio
                        controls
                        controlsList="nodownload"
                        style={audioStyle}
                      >
                        <source
                          src={contentPopUpSrc}
                          type={`audio/${contentPopUpFormat}`}
                        />
                        Your browser does not support the audio element.
                      </audio>
                      <div className="my-4">
                        <ul className="viewContentLi">
                          <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                          <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                          <li className="my-3">{`${viewContentPopUpDetails.te_productname}`}</li>
                          <li className="my-3">
                            {viewContentPopUpDetails.te_contentdescription}
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                  {contentPopUpType === "text" && (
                    <div
                      className="p-2 shadow-sm"
                      style={{ height: "300px", overflow: "auto" }}
                    >
                      {contentPopUpSrc}
                    </div>
                  )}
                  {contentPopUpType === "file" && (
                    <div>
                      <h3 className="my-3 ps-2">
                        <strong>
                          {viewContentPopUpDetails.te_contentname}
                        </strong>
                      </h3>
                      {contentPopUpFormat === "pdf" ? (
                        <div className="d-flex">
                          <div className="p-2" style={{ width: "100%" }}>
                            <object
                              data={`${contentPopUpSrc}#toolbar=0`}
                              type="application/pdf"
                              style={{ height: "70vh", width: "100%" }}
                            >
                              <iframe
                                src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                                  contentPopUpSrc
                                )}&embedded=true`}
                                title={`Document viewer for ${viewContentPopUpDetails.te_contentname}`}
                                style={{ height: "70vh", width: "100%" }}
                              />
                            </object>
                          </div>
                          <div className="p-2">
                            <div className="my-4">
                              <ul className="viewContentLi">
                                <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                                <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                                <li className="my-3">{`${viewContentPopUpDetails.te_productname}`}</li>
                                <li className="my-3">
                                  {
                                    viewContentPopUpDetails.te_contentdescription
                                  }
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ) : ["doc", "docx", "odt"].includes(
                          contentPopUpFormat
                        ) ? (
                        <div className="d-flex">
                          <div className="p-2" style={{ width: "100%" }}>
                            <iframe
                              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                contentPopUpSrc
                              )}`}
                              title={`Document viewer for ${viewContentPopUpDetails.te_contentname}`}
                              style={{ height: "70vh", width: "100%" }}
                            />
                          </div>
                          <div className="p-2">
                            <div className="my-4">
                              <ul className="viewContentLi">
                                <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                                <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                                <li className="my-3">{`${viewContentPopUpDetails.te_productname}`}</li>
                                <li className="my-3">
                                  {
                                    viewContentPopUpDetails.te_contentdescription
                                  }
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      ) : contentPopUpFormat === "txt" ? (
                        <iframe
                          src={contentPopUpSrc}
                          style={{ width: "100%", height: "80vh" }}
                          title={`Document viewer for ${viewContentPopUpDetails.te_contentname}`}
                        />
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </Modal>
          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListContent;
